
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("b6QLO", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $jdv4R = parcelRequire("jdv4R");


var $kb1I3 = parcelRequire("kb1I3");


var $3sXr4 = parcelRequire("3sXr4");

const $79c6915ee8b28dcd$var$messages = (0, $kSwu1.defineMessages)({
    rovoIsThinking: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    analyzingContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.analyzing-content",
        defaultMessage: "Analyzing your content"
    },
    puttingPiecesTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.putting-pieces-together",
        defaultMessage: "Putting the pieces together"
    },
    structuringRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.structuring-remix",
        defaultMessage: "Structuring your remix"
    },
    designingRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.designing-remix",
        defaultMessage: "Designing your remix"
    },
    structuringYourContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.structuring-content",
        defaultMessage: "Structuring your content"
    },
    designingYourContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.designing-content",
        defaultMessage: "Designing your content"
    },
    addingItAllTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.adding-it-all-together",
        defaultMessage: "Adding it all together"
    },
    applyingFinalTouches: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.applying-final-touches",
        defaultMessage: "Applying the final touches"
    },
    almostDone: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.almost-done",
        defaultMessage: "Almost done"
    }
});
const $79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance = (0, $kSwu1.defineMessages)({
    rovoIsImagining: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.rovo-is-imagining",
        defaultMessage: "Rovo is dreaming it up"
    },
    sketchingSomeIdeas: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.sketching-some-ideas",
        defaultMessage: "Sketching ideas"
    },
    mixingTheColors: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.mixing-the-colors",
        defaultMessage: "Mixing colors"
    },
    findingTheRightStyle: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.finding-the-right-style",
        defaultMessage: "Finding the right style"
    },
    bringingItToLife: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.bringing-it-to-life",
        defaultMessage: "Bringing it to life"
    },
    addingTheDetails: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.adding-the-details",
        defaultMessage: "Adding details"
    },
    applyingTheFinalTouches: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.applying-the-final-touches",
        defaultMessage: "Applying final touches"
    },
    almostDone: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.image-almost-done",
        defaultMessage: "Almost done"
    }
});
const $79c6915ee8b28dcd$var$styles = {
    rovoWrapperFixed: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1mT5xdy1CL _0Bm75G5zaO _3OE6xY1Y8M _4ApkO21Y8M _39xV02E6Kk _4ouGXIla9Q _42Yu6BbFo4",
    rovoWrapperFixedContentCentered: "_1mT5xdy1CL _0Bm75G5zaO _39xV02E6Kk _4ouGXIla9Q _1VJPcajssS _42Yu6BbFo4",
    parentDetector: "_1mT5xdWVPG _0fKRyPnQyn _1pp6NdYbGa",
    rovoWrapperAbsolute: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1mT5xdWVPG _0Bm75G5zaO _3OE6xY1Y8M _4ApkO21Y8M _39xV02E6Kk _4ouGXIla9Q _42Yu6BbFo4",
    rovoWrapperRelative: "_1mT5xdRAKS _4ouGXIla9Q _0Of8r25zaO _1wydGW5zaO"
};
function $79c6915ee8b28dcd$export$d6f2d83daf5efc44({ isWaitingForInput: isWaitingForInput = false, onStop: onStop, remixAttemptId: remixAttemptId, optionType: _optionType, isRelative: isRelative = false, loadingBarType: loadingBarType = isRelative ? 'mini-bar' : 'big-bar', showProgressBar: showProgressBar = false, isComplete: isComplete = false, onCompleteAnimationFinished: onCompleteAnimationFinished, contentType: contentType, isRemixEntrance: isRemixEntrance = true, shouldMeasureContentBounds: shouldMeasureContentBounds = false }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const loadingBarExperienceInstanceId = (0, $cozmU.useId)();
    const loadingBarMetadataRef = (0, $cozmU.useRef)({
        remixAttemptId: remixAttemptId,
        loadingBarType: loadingBarType,
        contentType: contentType,
        optionType: _optionType,
        isRemixEntrance: isRemixEntrance,
        hasCompletionHandshake: onCompleteAnimationFinished !== undefined
    });
    (0, $cozmU.useEffect)(()=>{
        const loadingBarExperience = (0, $jdv4R.createRemixLoadingBarExperience)(loadingBarExperienceInstanceId);
        loadingBarExperience.start();
        loadingBarExperience.addMetadata(loadingBarMetadataRef.current);
        if (loadingBarMetadataRef.current.isRemixEntrance) sendAnalyticsEvent({
            eventType: 'screen',
            name: 'remixProgressIndicator',
            attributes: {
                remixType: loadingBarMetadataRef.current.optionType
            }
        });
        return ()=>{
            loadingBarExperience.success();
        };
    }, [
        loadingBarExperienceInstanceId,
        sendAnalyticsEvent
    ]);
    const positionAbsolute = contentType === 'jira.issue'; // Confluence page remix uses the fixed/overlay path (no `contentType`, not `isRelative`).
    // Center the bar over the content area instead of the viewport so it stays aligned when a
    // sidenav/sidebar is open. Jira (`positionAbsolute`) is unaffected.
    const shouldCenterOnContent = shouldMeasureContentBounds; // Measure the content container (the detector marker's parent) so the fixed bar can be
    // centered on the content rather than the viewport. Re-measures on container resize, which
    // covers a sidenav/sidebar opening or closing. Stays viewport-centered until measured.
    const parentDetectorRef = (0, $cozmU.useRef)(null);
    const [contentCenterX, setContentCenterX] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldCenterOnContent) return;
        const parentContainer = parentDetectorRef.current?.parentElement;
        if (!parentContainer) return;
        const updateCenter = ()=>{
            const rect = parentContainer.getBoundingClientRect();
            setContentCenterX(rect.left + rect.width / 2);
        };
        const resizeObserver = new ResizeObserver(updateCenter);
        resizeObserver.observe(parentContainer);
        updateCenter();
        return ()=>resizeObserver.disconnect();
    }, [
        shouldCenterOnContent
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const thinkingTexts = [
        formatMessage($79c6915ee8b28dcd$var$messages.rovoIsThinking),
        formatMessage($79c6915ee8b28dcd$var$messages.analyzingContent),
        formatMessage($79c6915ee8b28dcd$var$messages.puttingPiecesTogether),
        formatMessage($79c6915ee8b28dcd$var$messages.structuringRemix),
        formatMessage($79c6915ee8b28dcd$var$messages.designingRemix),
        formatMessage($79c6915ee8b28dcd$var$messages.addingItAllTogether),
        formatMessage($79c6915ee8b28dcd$var$messages.applyingFinalTouches),
        formatMessage($79c6915ee8b28dcd$var$messages.almostDone)
    ];
    const thinkingTextsNonRemixEntrance = [
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.rovoIsImagining),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.sketchingSomeIdeas),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.mixingTheColors),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.findingTheRightStyle),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.bringingItToLife),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.addingTheDetails),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.applyingTheFinalTouches),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.almostDone)
    ];
    const barContent = /*#__PURE__*/ $cozmU.createElement((0, $3sXr4.RovoThinkingBarWrapper), {
        isThinking: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $kb1I3.RovoThinkingBar // Completion is terminal even if a waiting-state update is briefly stale.
    ), {
        status: isWaitingForInput && !isComplete ? 'waiting' : 'analyzing',
        onStop: onStop,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        useRotatingTitle: true,
        customRotatingMessages: isRemixEntrance ? thinkingTexts : thinkingTextsNonRemixEntrance
    })); // Content-centered fixed path (Confluence view page, gated + opted in via
    // `shouldMeasureContentBounds`). Renders a hidden marker so the content container can be
    // measured, then centers the fixed bar on the content's horizontal midpoint. Falls back to
    // viewport-centering (`left: 50%`) until the measurement resolves.
    if (!isRelative && !positionAbsolute && shouldCenterOnContent) return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: parentDetectorRef,
        xcss: $79c6915ee8b28dcd$var$styles.parentDetector,
        testId: "remix-thinking-bar-parent-detector"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $79c6915ee8b28dcd$var$styles.rovoWrapperFixedContentCentered,
        style: {
            left: contentCenterX != null ? `${contentCenterX}px` : '50%'
        },
        testId: "remix-thinking-bar-gradient-border"
    }, barContent));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: // eslint-disable-next-line no-nested-ternary
        isRelative ? $79c6915ee8b28dcd$var$styles.rovoWrapperRelative : positionAbsolute ? $79c6915ee8b28dcd$var$styles.rovoWrapperAbsolute : $79c6915ee8b28dcd$var$styles.rovoWrapperFixed,
        testId: "remix-thinking-bar-gradient-border"
    }, barContent);
}
module.exports["RemixThinkingBar"] = $79c6915ee8b28dcd$export$d6f2d83daf5efc44;

});

parcelRegister("jdv4R", function(module, exports) {

var $cNAch = parcelRequire("cNAch");


var $4MiWC = parcelRequire("4MiWC");

const $8d105d30086155d7$export$4be31113674d294a = (instanceId)=>new (0, $cNAch.UFOExperience)('remix-loading-bar', {
        type: (0, $4MiWC.ExperienceTypes).Experience,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult
    }, instanceId);
module.exports["createRemixLoadingBarExperience"] = $8d105d30086155d7$export$4be31113674d294a;

});

parcelRegister("8GyO5", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $cbY7C = parcelRequire("cbY7C");


var $03RpJ = parcelRequire("03RpJ");


var $1hQ0e = parcelRequire("1hQ0e");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $1qYXT = parcelRequire("1qYXT");


var $crsgV = parcelRequire("crsgV");


var $b6QLO = parcelRequire("b6QLO");

const $1babe6d267af7ec0$var$randomId = ()=>{
    if (globalThis?.crypto?.randomUUID) return globalThis.crypto.randomUUID();
     // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- uuid is used as a fallback for environments where crypto.randomUUID is unavailable
    return (0, $03RpJ.default)();
};
const $1babe6d267af7ec0$var$styles = {
    anchorTrigger: "_1mT5xdy1CL _1pp6NdYbGa"
}; /**
    * Builds a `RemixPopup` `trigger` render function from a plain DOM rect snapshot: an invisible,
    * fixed-position div matching the rect's bounds, which the popup anchors to. Used for entry points
    * that don't have a persistent trigger element (e.g. a floating/selection toolbar, or a button that
    * may unmount while the flow is active) — they instead capture `getBoundingClientRect()` (or the
    * current selection's rect) once, at click time.
    *
    * Portaled directly to the top-level document body: `RemixContainer` can be mounted anywhere in a product's DOM
    * tree (e.g. deep inside an editor's content component), and `position: fixed` is only viewport-
    * relative when none of its ancestors have a `transform`/`filter`/`will-change` — which editors
    * commonly do for scroll/sticky containers. Portaling avoids inheriting any such ancestor, so the
    * rect is always interpreted relative to the viewport, matching where it was captured.
    */ 
function $1babe6d267af7ec0$var$buildAnchorRectTrigger(anchorRect) {
    return (triggerProps)=>{
        const document = (0, $1hQ0e.getDocument)();
        if (!document?.body) return null;
        return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ...triggerProps,
            xcss: $1babe6d267af7ec0$var$styles.anchorTrigger,
            style: {
                top: anchorRect.top,
                left: anchorRect.left,
                width: anchorRect.width,
                height: anchorRect.height
            },
            "aria-hidden": "true"
        }), document.body);
    };
} /**
   * Props for the Remix container composed entry point.
   */ 
function $1babe6d267af7ec0$export$d2a66369b43f5d65({ isWaitingForInput: isWaitingForInput = false, onClose: onClose, remixAttemptId: remixAttemptId, onOptionSelect: onOptionSelect, onRemixFlowActiveChange: onRemixFlowActiveChange, hideThinkingBar: hideThinkingBar = false, isEphemeralViewVisible: isEphemeralViewVisible = false, skipThinkingTypes: skipThinkingTypes, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle, cascadingMenuHeader: cascadingMenuHeader, presentation: presentation = 'modal', trigger: trigger, anchorRect: anchorRect, popupPlacement: popupPlacement, popupOffset: popupOffset, isPopupOpen: isPopupOpen = true, isOptionSelectBlocked: isOptionSelectBlocked = false, shouldCloseOnScroll: shouldCloseOnScroll = false, shouldPreserveEditorFocus: shouldPreserveEditorFocus = false, popupRepositionKey: popupRepositionKey, showProgressBar: showProgressBar = false, isComplete: isComplete = false, isThinking: controlledIsThinking, onCompleteAnimationFinished: onCompleteAnimationFinished, contentType: contentType, autoSubmitUserPrompt: autoSubmitUserPrompt, autoSubmitSelection: autoSubmitSelection, onStopThinking: onStopThinking, isRemixEntrance: isRemixEntrance = true, shouldMeasureContentBounds: shouldMeasureContentBounds = false }) {
    // for editor, isThinking will be passed in, which is stored in editor state
    // Auto-submitted prompts/selections should skip the option picker on first render.
    const [localIsThinking, setLocalIsThinking] = (0, $cozmU.useState)(!!autoSubmitUserPrompt || !!autoSubmitSelection);
    const isThinking = controlledIsThinking ?? localIsThinking;
    const [localRemixAttemptId, setLocalRemixAttemptId] = (0, $cozmU.useState)();
    const localRemixAttemptIdRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        var _localRemixAttemptIdRef;
        if (!isThinking || remixAttemptId) {
            localRemixAttemptIdRef.current = undefined;
            setLocalRemixAttemptId(undefined);
            return;
        }
        (_localRemixAttemptIdRef = localRemixAttemptIdRef).current ?? (_localRemixAttemptIdRef.current = $1babe6d267af7ec0$var$randomId());
        setLocalRemixAttemptId(localRemixAttemptIdRef.current);
    }, [
        isThinking,
        remixAttemptId
    ]);
    const currentRemixAttemptId = remixAttemptId ?? localRemixAttemptId;
    const [selectedOptionType, setSelectedOptionType] = (0, $cozmU.useState)(); // Prevent the option picker flashing after a cancelled auto-submit flow.
    const [isCancelledAutoSubmit, setIsCancelledAutoSubmit] = (0, $cozmU.useState)(false);
    const showThinkingBar = isThinking && currentRemixAttemptId !== undefined && !isEphemeralViewVisible && !hideThinkingBar; // Read the cohort without recording an exposure. Only the control and variant1 groups ever
    // open this component, so recording the exposure here would leave the variant2 group
    // uncounted. The exposure is recorded by each Remix entry point instead, at the moment the
    // cohort decides which Remix picker to open, which is a moment all three groups share.
    const remixMenuCohort = (0, $2pQiO.UNSAFE_expValNoExposure)((0, $1qYXT.REMIX_MENU_EXPERIMENT), (0, $1qYXT.REMIX_MENU_COHORT_PARAM), (0, $1qYXT.REMIX_MENU_CONTROL_COHORT));
    const isDropdownVariantEnabled = remixMenuCohort === (0, $1qYXT.REMIX_MENU_INLINE_DROPDOWN_COHORT);
    const effectiveTrigger = trigger ?? (isDropdownVariantEnabled && anchorRect ? $1babe6d267af7ec0$var$buildAnchorRectTrigger(anchorRect) : undefined);
    const effectivePresentation = isDropdownVariantEnabled && effectiveTrigger ? 'popup' : presentation; // When a selection is pre-supplied (the picker lives elsewhere, e.g. the editor
    // toolbar Remix dropdown), fire it once on mount and never render the in-app
    // picker. This runs even when a controlled `isThinking={false}` is passed.
    const hasAutoSubmittedSelectionRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasAutoSubmittedSelectionRef.current || !autoSubmitSelection) return;
        hasAutoSubmittedSelectionRef.current = true;
        setSelectedOptionType(autoSubmitSelection.type);
        setLocalIsThinking(true);
        onRemixFlowActiveChange?.(true);
        onOptionSelect?.(autoSubmitSelection); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        autoSubmitSelection?.type,
        autoSubmitSelection?.subType,
        autoSubmitSelection?.userPrompt
    ]);
    const handleOptionSelect = (0, $cozmU.useCallback)((params)=>{
        if (isOptionSelectBlocked) return;
        if (!skipThinkingTypes?.has(params.type)) setLocalIsThinking(true);
        setSelectedOptionType(params.type);
        onRemixFlowActiveChange?.(true);
        onOptionSelect?.(params);
    }, [
        isOptionSelectBlocked,
        onOptionSelect,
        onRemixFlowActiveChange,
        skipThinkingTypes
    ]);
    const handleStopThinking = (0, $cozmU.useCallback)(()=>{
        // Record the local cancellation before aborting the request or dismissing the host UI. The
        // lifecycle owner uses this intent to distinguish a Loading Bar stop from a Rovo-side abort;
        // calling onStopThinking first can release the request and unmount the owner before that
        // distinction reaches the machine settlement handler.
        onRemixFlowActiveChange?.(false);
        setLocalIsThinking(false);
        if (autoSubmitUserPrompt) setIsCancelledAutoSubmit(true);
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) onStopThinking?.();
         // for insertion, when cancel, the logic is from ProseMirror, we'll show the modal again and
    // - we call onRemixFlowActiveChange in useEffect to cancel the request
    // but for update, when cancel, the logic is from UI, we have to call onRemixFlowActiveChange manually
    // - cause the component tree will be unmounted and the useEffect will not be called
    }, [
        autoSubmitUserPrompt,
        onRemixFlowActiveChange,
        onStopThinking
    ]); // only when show the thinking bar, we handle the escape key to stop the thinking
    // when the thinking bar is rendered in editor, the escape will also be handled by editor
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
            if (!showThinkingBar) return;
        } else {
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) return;
            if (!isThinking) return;
        }
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') handleStopThinking();
            }
        });
    }, [
        isThinking,
        handleStopThinking,
        showThinkingBar
    ]); // Keep the trigger mounted so Popup can stay anchored.
    if (effectivePresentation === 'popup' && effectiveTrigger) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crsgV.RemixPopup), {
        isOpen: isPopupOpen && !isThinking,
        onClose: onClose,
        trigger: effectiveTrigger,
        placement: popupPlacement,
        offset: popupOffset,
        useCascadingMenu: isDropdownVariantEnabled,
        cascadingMenuHeader: cascadingMenuHeader,
        shouldCloseOnScroll: shouldCloseOnScroll,
        shouldPreserveEditorFocus: shouldPreserveEditorFocus,
        onOptionSelect: handleOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle,
        repositionKey: popupRepositionKey
    }), showThinkingBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
        isWaitingForInput: isWaitingForInput,
        remixAttemptId: currentRemixAttemptId,
        loadingBarType: "big-bar",
        onStop: handleStopThinking,
        optionType: selectedOptionType,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        contentType: contentType,
        isRemixEntrance: isRemixEntrance,
        shouldMeasureContentBounds: shouldMeasureContentBounds
    }));
     // Modal mode (default).
    if (isThinking) {
        if (showThinkingBar) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
            isWaitingForInput: isWaitingForInput,
            remixAttemptId: currentRemixAttemptId,
            loadingBarType: "big-bar",
            onStop: handleStopThinking,
            optionType: selectedOptionType,
            showProgressBar: showProgressBar,
            isComplete: isComplete,
            onCompleteAnimationFinished: onCompleteAnimationFinished,
            contentType: contentType,
            isRemixEntrance: isRemixEntrance,
            shouldMeasureContentBounds: shouldMeasureContentBounds
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    } // Auto-submit cancellation leaves reopening to the caller.
    if (isCancelledAutoSubmit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
     // Never render the in-app option-picker when a selection is pre-supplied — the
    // picker lives elsewhere (e.g. the editor toolbar Remix dropdown). The mount
    // only exists to run the flow; the auto-submit effect above starts it.
    if (autoSubmitSelection) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crsgV.RemixOverlay), {
        onClose: onClose,
        onOptionSelect: handleOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle
    });
}
module.exports["RemixContainer"] = $1babe6d267af7ec0$export$d2a66369b43f5d65;

});

parcelRegister("1qYXT", function(module, exports) {
const $f654d7d76017903f$export$dbf8cbce125113dc = 'cc-ce-maui-remix-menu-multivariant';
const $f654d7d76017903f$export$2c70a635cf90671d = 'cohort';
const $f654d7d76017903f$export$3d85c6890e42c40 = 'control';
const $f654d7d76017903f$export$c3c6fd65e75f7a5b = 'variant1';
const $f654d7d76017903f$export$7004846771b000c0 = [
    'mediaSingle',
    'mediaGroup',
    'media',
    'image',
    'extension',
    'bodiedExtension',
    'multiBodiedExtension',
    'embedCard',
    'blockCard',
    'inlineCard',
    // Source blocks
    'bodiedSyncBlock',
    // Reference blocks
    'syncBlock',
    'expand',
    'nestedExpand'
];
const $f654d7d76017903f$var$DENY_SET = new Set($f654d7d76017903f$export$7004846771b000c0);
const $f654d7d76017903f$export$bf9aef57175a93a2 = (nodeType)=>$f654d7d76017903f$var$DENY_SET.has(nodeType);
const $f654d7d76017903f$export$f5b180e87c8cf581 = 'cc_maui_polish_changes_batch_7';
const $f654d7d76017903f$export$937cbf4f7cf583ee = [
    'expand',
    'nestedExpand'
];
const $f654d7d76017903f$var$EXPAND_NODE_TYPES = new Set($f654d7d76017903f$export$937cbf4f7cf583ee);
const $f654d7d76017903f$export$abcc4815bdfd056c = (nodeType, areExpandsEnabled)=>{
    if ($f654d7d76017903f$var$EXPAND_NODE_TYPES.has(nodeType) && areExpandsEnabled()) return false;
    return $f654d7d76017903f$export$bf9aef57175a93a2(nodeType);
};
const $f654d7d76017903f$export$a7b703a84f6e523d = (extensionKey, allowList)=>extensionKey !== undefined && allowList.includes(extensionKey);
module.exports["REMIX_MENU_EXPERIMENT"] = $f654d7d76017903f$export$dbf8cbce125113dc;
module.exports["REMIX_MENU_COHORT_PARAM"] = $f654d7d76017903f$export$2c70a635cf90671d;
module.exports["REMIX_MENU_CONTROL_COHORT"] = $f654d7d76017903f$export$3d85c6890e42c40;
module.exports["REMIX_MENU_INLINE_DROPDOWN_COHORT"] = $f654d7d76017903f$export$c3c6fd65e75f7a5b;
module.exports["REMIX_DENY_LIST_V1"] = $f654d7d76017903f$export$7004846771b000c0;
module.exports["isRemixRestrictedNodeType"] = $f654d7d76017903f$export$bf9aef57175a93a2;
module.exports["REMIX_EXPANDS_EXPERIMENT"] = $f654d7d76017903f$export$f5b180e87c8cf581;
module.exports["REMIX_EXPAND_NODE_TYPES"] = $f654d7d76017903f$export$937cbf4f7cf583ee;
module.exports["isRemixRestrictedNodeTypeWithExpands"] = $f654d7d76017903f$export$abcc4815bdfd056c;
module.exports["isAllowedMBEExtensionForRemix"] = $f654d7d76017903f$export$a7b703a84f6e523d;

});

parcelRegister("crsgV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $dTHYM = parcelRequire("dTHYM");


var $I7hWB = parcelRequire("I7hWB");


var $f6cdQ = parcelRequire("f6cdQ");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lSQgn = parcelRequire("lSQgn");


var $cJ0FD = parcelRequire("cJ0FD");


var $fEPJS = parcelRequire("fEPJS");


var $7aRdF = parcelRequire("7aRdF");


var $aRGok = parcelRequire("aRGok");


var $2LyZS = parcelRequire("2LyZS");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $e3Wrf = parcelRequire("e3Wrf");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $kDDrf = parcelRequire("kDDrf");


var $bjY3F = parcelRequire("bjY3F");


var $fkYYP = parcelRequire("fkYYP");


var $HvNsc = parcelRequire("HvNsc");


var $1LRKz = parcelRequire("1LRKz");


var $czfXc = parcelRequire("czfXc");


var $dcNzQ = parcelRequire("dcNzQ");


var $9z4Bk = parcelRequire("9z4Bk");


var $loej8 = parcelRequire("loej8");

const $be6de585ac044839$var$headerOuterStyle = null;
const $be6de585ac044839$var$headerOuterMinimizedStyle = null;
const $be6de585ac044839$var$labsPositionStyle = null;
const $be6de585ac044839$var$cascadingHeaderWrapperStyle = null;
const $be6de585ac044839$var$headerIconWrapperStyle = null;
const $be6de585ac044839$var$headerIconWrapperMinimizedStyle = null; // 92px = space.300 (24px top padding) + 64px icon + 4px gap
const $be6de585ac044839$var$headerHeadingStyle = null; // left: 16px (space.200) + 48px icon + 8px gap = 72px
// top: vertically centered with 48px icon — icon center is at 16px + 24px = 40px,
// heading line-height ~24px, so top = 40px - 12px = 28px
const $be6de585ac044839$var$headerHeadingMinimizedStyle = null; // 120px = 92px heading top + ~28px heading height
const $be6de585ac044839$var$headerSubtitleStyle = null; // Hide subtitle in minimized state — fast fade out, delayed fade in handled by base style
const $be6de585ac044839$var$headerSubtitleMinimizedStyle = null;
const $be6de585ac044839$var$subtitleStyle = null; // 113px = 64px icon + 4px gap + ~28px heading + ~4px gap + ~13px subtitle
const $be6de585ac044839$var$headerSpacerStyle = null; // 48px = minimized icon height (no subtitle in minimized state)
const $be6de585ac044839$var$headerSpacerMinimizedStyle = null; // ── RemixSubTypeGrid styles ────────────────────────────────────────────────
const $be6de585ac044839$var$gridStyles = {
    grid: "_2mHwu82ADO _3iDTPbgBM8 _2iEGP2PTnU _39xV02N91d _46hvQm2ADO",
    tile: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _23rrnHyKLB _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VfI2J _0KLXruoI2d _0wOv4Q7zJH _0hPERGjOvk _1eOmH6d1Zr"
}; // ── RemixAccordionOption styles ────────────────────────────────────────────
const $be6de585ac044839$var$accordionStyles = {
    accordionWrapper: "_0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d",
    accordionHeader: "_0bjKvD8fU6 _2V7sgOdnbC _4c065U2ADO _39xV02N91d _0jFU0VpJKa _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0KLXru66of _0LQT5E8HPE _03SyCP8HPE _0wOv4Q7zJH",
    expandedContent: "_2Y7lL48HPE _0xmtkoPgdg",
    pickForMeWrapper: "_2Y7lL4gVvo _46hvQmgVvo _0xmtkogVvo _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _43nrzT8HPE"
};
const $be6de585ac044839$var$accordionCollapsedStyle = null;
const $be6de585ac044839$var$accordionExpandedStyle = null;
const $be6de585ac044839$var$revealContentStyle = null;
const $be6de585ac044839$var$pickForMeButtonStyle = null; // ── RemixOverlay styles ────────────────────────────────────────────────────
const $be6de585ac044839$var$modalContentWrapperStyle = null; // ── RemixPopup styles ──────────────────────────────────────────────────────
const $be6de585ac044839$var$subtleSlideIn = null;
const $be6de585ac044839$var$popupStyles = {
    popupEnterAnimation: "_1gBibyf9Pz _0nFVCG2HTN _43vdfTdisq _3Y6bKp38c8 _39Ohv4YbGa",
    contentWrapper: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _39xV02sz7G _0KLXrunmFW",
    cascadingContentWrapper: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrujOvk",
    body: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w",
    cascadingBody: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0aFT5vbt8w",
    cascadingHeader: "_39xV02N91d _2fwxA5DIqT",
    cascadingHeaderIcon: "_39xV02mdCj _0jFU0VmdCj"
};
const $be6de585ac044839$var$transparentPopupContainerStyle = null;
const $be6de585ac044839$var$CascadingPopupContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: _shouldRenderToParent, shouldFitContainer: _shouldFitContainer, appearance: _appearance, xcss: _xcss, isReferenceHidden: _isReferenceHidden, children: children, 'data-testid': dataTestId, 'data-placement': dataPlacement, ...htmlAttributes } = props;
    const verticalDirection = (0, $dcNzQ.getCascadeVerticalDirectionForPlacement)(dataPlacement);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcNzQ.CascadeVerticalDirectionContext).Provider, {
        value: verticalDirection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        "data-testid": dataTestId ?? 'remix-cascading-popup-container',
        "data-remix-cascading-popup": true,
        "data-toolbar-nested-dropdown-menu": true,
        "data-placement": dataPlacement,
        ...htmlAttributes,
        className: (0, $hekY6.default)([
            "_0KLXrujOvk _2OUyjtYbGa"
        ])
    }, children));
});
$be6de585ac044839$var$CascadingPopupContainer.displayName = 'CascadingPopupContainer';
const $be6de585ac044839$var$scrollableBodyStyle = null;
const $be6de585ac044839$var$remixStyles = {
    describeInputBorderWrapper: "_39xV02N91d _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    describeInputWrapper: "_4c065U8HPE _2Y7lL45zaO _39xV02N91d _0KLXrunmFW",
    compactDescribeInputWrapper: "_4c065UgVvo _2Y7lL42ADO _39xV02N91d _0KLXruoI2d",
    describePromptRow: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLz9WS _39xV02N91d",
    describeTextAreaWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4ouGXIdnbC",
    modalBodyPadding: "_2Y7lL45zaO _46hvQm1Y8M _0xmtko5zaO",
    remixOptionsStack: "_39xV02N91d"
}; // ── RemixOverlayHeader ─────────────────────────────────────────────────────
function $be6de585ac044839$var$RemixOverlayHeader({ subtitle: subtitle, isMinimized: isMinimized = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const subtitleMessage = subtitle ?? ((0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text') ? (0, $czfXc.default).subtitleUpdated : (0, $czfXc.default).subtitle); // Track minimized state changes to trigger the icon fade-out/fade-in animation.
    // When isMinimized changes, quickly fade out at the start, then fade back in
    // near the end of the 200ms position transition.
    const iconRef = (0, $cozmU.useRef)(null);
    const prevMinimizedRef = (0, $cozmU.useRef)(isMinimized);
    (0, $cozmU.useEffect)(()=>{
        if (prevMinimizedRef.current !== isMinimized) {
            prevMinimizedRef.current = isMinimized;
            const el = iconRef.current;
            if (el) {
                // Gently fade out (uses the 100ms ease-out opacity transition from the base style)
                el.style.opacity = '0'; // Near the end of the 200ms position transition, fade back in
                const timer = setTimeout(()=>{
                    el.style.opacity = '1';
                }, 130);
                return ()=>clearTimeout(timer);
            }
        }
    }, [
        isMinimized
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHTaix _1mT5xdRAKS _39xV02N91d _46hvQmNHnM _0xmtkoNHnM",
            isMinimized && "_46hvQm5zaO _0xmtko5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTon8HPE _4ApkO28HPE _1pp6NdYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fkYYP.RemixLabsLozenge), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: iconRef,
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_23rrnHxGK8 _1mT5xdWVPG _3OE6xY715P _2IhTonNHnM _1VJPcajssS _39xV029LX5 _0jFU0V9LX5",
            isMinimized && "_3OE6xY5zaO _2IhTon5zaO _1VJPcalna5 _39xV02pJKa _0jFU0VpJKa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($HvNsc))),
        alt: formatMessage((0, $czfXc.default).remixIconAlt),
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHYjhE _1mT5xdWVPG _3OE6xY715P _2IhTonaXQy _1VJPcajssS _1ANEUSLRg7",
            isMinimized && "_3OE6xYUudP _2IhToncM5X _1VJPcalna5"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: isMinimized ? 'medium' : 'large'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $czfXc.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHZWJM _1mT5xdWVPG _3OE6xY715P _2IhTonv6H3 _1VJPcajssS _1ANEUSLRg7",
            isMinimized && "_23rrnH52bh _1YKVNsdnbC _1pp6NdYbGa",
            "_1UtDYzKGUX"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), subtitleMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHRiH9 _0jFU0VU9z0",
            isMinimized && "_0jFU0VpJKa"
        ])
    }));
} // ── RemixSubTypeGrid ───────────────────────────────────────────────────────
function $be6de585ac044839$var$RemixSubTypeGrid({ isAnimatedArtworkEnabled: isAnimatedArtworkEnabled, subTypes: subTypes, onSubTypeSelect: onSubTypeSelect }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // Tiles opt into keyboard-focus artwork motion by rendering `data-remix-artwork-tile`, which the
    // artwork stylesheets key their `:focus-visible` rules off.
    const isKeyboardArtworkMotionEnabled = (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_7');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$gridStyles.grid
    }, subTypes.map((subType, motionIndex)=>{
        const IconComponent = (0, $9z4Bk.getSubTypeIconComponent)(subType.value, isAnimatedArtworkEnabled);
        const label = formatMessage(subType.labelMessage);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: subType.value,
            content: label,
            position: "top",
            delay: 0,
            ignoreTooltipPointerEvents: true
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...tooltipProps,
                ...isKeyboardArtworkMotionEnabled ? {
                    'data-remix-artwork-tile': true
                } : {},
                xcss: $be6de585ac044839$var$gridStyles.tile,
                onClick: ()=>onSubTypeSelect(subType.value),
                testId: subType.testId,
                "aria-label": label
            }, IconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                alt: label,
                motionIndex: motionIndex
            }) : null));
    }));
} // ── RemixAccordionOption ───────────────────────────────────────────────────
const $be6de585ac044839$var$animationConfig = {
    duration: ()=>450
}; // Tracks preloaded option/theme/cohort groups to avoid duplicate work.
const $be6de585ac044839$var$preloadedIconGroups = new Set(); /**
                                                * Preloads sub-type icon images for a remix option so they display instantly
                                                * when the accordion expands. Only fetches icons for the active color mode.
                                                */ 
function $be6de585ac044839$var$preloadSubTypeIcons(option, colorMode, isAnimatedArtworkEnabled) {
    const preloadKey = `${option.type}-${colorMode}-${isAnimatedArtworkEnabled}`;
    if ($be6de585ac044839$var$preloadedIconGroups.has(preloadKey)) return;
    $be6de585ac044839$var$preloadedIconGroups.add(preloadKey);
    const isDark = colorMode === 'dark';
    for (const subType of option.subTypes){
        if (isAnimatedArtworkEnabled) {
            const animatedUrls = (0, $9z4Bk.getAnimatedSubTypeIconUrls)(subType.value);
            if (animatedUrls) {
                const img = new window.Image();
                img.src = isDark ? animatedUrls.dark : animatedUrls.light;
                continue;
            }
            if ((0, $9z4Bk.hasAnimatedSubTypeIcon)(subType.value)) continue;
        }
        const urls = (0, $1LRKz.SUB_TYPE_ICON_URLS)[subType.value];
        if (urls) {
            const img = new window.Image();
            img.src = isDark ? urls.dark : urls.light;
        }
    }
}
const $be6de585ac044839$var$renderOptionIcon = (option, alt)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: option.icon,
        label: alt,
        appearance: option.iconTileAppearance ?? 'gray',
        size: "small"
    });
};
function $be6de585ac044839$var$RemixAccordionOption({ option: option, isExpanded: isExpanded, isAnimatedArtworkEnabled: isAnimatedArtworkEnabled, onToggle: onToggle, onSubTypeSelect: onSubTypeSelect, onPickForMe: onPickForMe, colorMode: colorMode }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const smoothResizer = (0, $2LyZS.useResizingHeight)($be6de585ac044839$var$animationConfig);
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        onToggle(option.type);
    }, [
        onToggle,
        option.type
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        $be6de585ac044839$var$preloadSubTypeIcons(option, colorMode, isAnimatedArtworkEnabled);
    }, [
        option,
        colorMode,
        isAnimatedArtworkEnabled
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((subTypeValue)=>{
        if ((0, $iDrrr.fg)('cc-maui-phase-3')) {
            const subTypeDef = option.subTypes.find((st)=>st.value === subTypeValue);
            onSubTypeSelect(subTypeDef?.emitType ?? option.type, subTypeValue);
            return;
        }
        onSubTypeSelect(option.type, subTypeValue);
    }, [
        onSubTypeSelect,
        option.type,
        option.subTypes
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)(()=>{
        onPickForMe(option.type);
    }, [
        onPickForMe,
        option.type
    ]);
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))) : (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX)));
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            isExpanded ? "_0bjKvD8fU6 _0KLXruoI2d" : "_23rrnHC1jD _0bjKvD8fU6 _0KLXruoI2d _1eOmH6d1Zr _3fSdSTGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionHeader,
        onClick: handleToggle,
        onMouseEnter: handleMouseEnter,
        testId: option.testId,
        "aria-expanded": isExpanded,
        "aria-label": formatMessage(option.labelMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, $be6de585ac044839$var$renderOptionIcon(option, optionIconAlt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage(option.labelMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
        label: "",
        color: "var(--ds-icon, #292A2E)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: smoothResizer.ref,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn"
        ])
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$accordionStyles.expandedContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixSubTypeGrid, {
        isAnimatedArtworkEnabled: isAnimatedArtworkEnabled,
        subTypes: option.subTypes,
        onSubTypeSelect: handleSubTypeSelect
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$accordionStyles.pickForMeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2mpnYbKxmn _46PhP8u7m9 _2FH9z4N91d"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handlePickForMe,
        testId: `${option.testId}-pick-for-me`
    }, formatMessage((0, $czfXc.default).pickForMe))))))));
}
const $be6de585ac044839$var$RemixFlatOption = ({ option: option, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onSelect(option.type);
    }, [
        onSelect,
        option.type
    ]);
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHC1jD _0bjKvD8fU6 _0KLXruoI2d _1eOmH6d1Zr _3fSdSTGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionHeader,
        onClick: handleClick,
        testId: option.testId,
        "aria-label": formatMessage(option.labelMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, $be6de585ac044839$var$renderOptionIcon(option, optionIconAlt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage(option.labelMessage))))));
};
function $be6de585ac044839$var$setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
        return;
    }
    if (ref) ref.current = value;
}
function $be6de585ac044839$var$RemixOpenMenuExperienceTracker() {
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        (0, $kDDrf.succeedRemixOpenMenuExperience)(experienceTracker);
    }, [
        experienceTracker
    ]);
    return null;
} /**
   * Placements supported by the anchored RemixPopup.
   * - 'left-end': contextual object-level entry point (opens to the left).
   * - 'bottom-start': toolbar "Remix" button dropdown (opens downward, aligned to trigger start).
   * - 'bottom-end': toolbar "Remix" button dropdown when the cascade needs left-side room.
   */ 
const $be6de585ac044839$var$stopEditorNativeEvent = (event)=>{
    // Block controls and block-menu hosts install native document/editor listeners before
    // React's delegated handlers. Stop at the textarea DOM boundary so focusing the prompt
    // cannot be interpreted as an outside click. Do not preventDefault: native focus and
    // text editing must continue to work.
    event.stopPropagation();
    event.stopImmediatePropagation();
};
const $be6de585ac044839$var$bindEditorNativeEventListeners = (element)=>(0, $cbY7C.bindAll)(element, [
        {
            type: 'mousedown',
            listener: $be6de585ac044839$var$stopEditorNativeEvent
        },
        {
            type: 'mouseup',
            listener: $be6de585ac044839$var$stopEditorNativeEvent
        },
        {
            type: 'click',
            listener: $be6de585ac044839$var$stopEditorNativeEvent
        }
    ]); /**
      * Suppress the default focus transfer for a press inside the menu. `click` still fires, so option
      * selection works. Text controls are exempt because they must be focusable to be typed into.
      */ 
const $be6de585ac044839$var$preserveFocusOnPress = (event)=>{
    const target = event.target;
    if (target instanceof Element && target.closest('textarea, input, select, [contenteditable="true"]') !== null) return;
    event.preventDefault();
};
const $be6de585ac044839$var$bindPreserveFocusListener = (element)=>(0, $cbY7C.bind)(element, {
        type: 'mousedown',
        listener: $be6de585ac044839$var$preserveFocusOnPress
    }); /**
     * Keeps Tab away from `@confluence/highlight-actions`' `document`-level listener, which claims every
     * Tab while its selection toolbar is mounted — as it still is when the picker is opened by keyboard.
     * Modal only: ADS `Popup` needs Tab to reach `window` to close and restore focus on tab-out.
     */ 
const $be6de585ac044839$var$stopTabAtPickerBoundary = (event)=>{
    if (event.key === 'Tab') event.stopPropagation();
}; /**
    * Callback ref so the listener re-attaches when the picker is closed and reopened.
    */ 
function $be6de585ac044839$var$useTabBoundaryRef() {
    const unbindRef = (0, $cozmU.useRef)(null);
    return (0, $cozmU.useCallback)((element)=>{
        unbindRef.current?.();
        unbindRef.current = element ? (0, $cbY7C.bind)(element, {
            type: 'keydown',
            listener: $be6de585ac044839$var$stopTabAtPickerBoundary
        }) : null;
    }, []);
}
function $be6de585ac044839$var$RemixDescribeInput({ value: value, onChange: onChange, onSubmit: onSubmit, autoFocus: autoFocus = false, isCompact: isCompact = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const describeTextAreaRef = (0, $cozmU.useRef)(null);
    const unbindDescribeInputBoundaryRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!autoFocus) return;
         // requestAnimationFrame so focus lands after the modal has fully mounted.
        const raf = requestAnimationFrame(()=>{
            describeTextAreaRef.current?.focus();
        });
        return ()=>cancelAnimationFrame(raf);
    }, [
        autoFocus
    ]);
    const setDescribeInputBoundaryRef = (0, $cozmU.useCallback)((element)=>{
        unbindDescribeInputBoundaryRef.current?.();
        unbindDescribeInputBoundaryRef.current = element && isCompact ? $be6de585ac044839$var$bindEditorNativeEventListeners(element) : null;
    }, [
        isCompact
    ]);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        if (value?.trim()) onSubmit();
    }, [
        value,
        onSubmit
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
        }
    }, [
        handleSubmit
    ]);
    const placeholder = formatMessage((0, $iDrrr.fg)('cc_maui_updated_remix_tooltip_text') ? (0, $czfXc.default).describePlaceholderUpdated : (0, $czfXc.default).describePlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.describeInputBorderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: isCompact ? setDescribeInputBoundaryRef : undefined,
        xcss: isCompact ? $be6de585ac044839$var$remixStyles.compactDescribeInputWrapper : $be6de585ac044839$var$remixStyles.describeInputWrapper,
        testId: "remix-overlay-describe-input-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $be6de585ac044839$var$remixStyles.describePromptRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.describeTextAreaWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        ref: describeTextAreaRef,
        appearance: "none",
        placeholder: placeholder,
        value: value,
        onChange: (e)=>onChange(e.currentTarget.value),
        onKeyDown: handleKeyDown,
        isCompact: true,
        minimumRows: 1,
        maxHeight: "200px",
        resize: "smart",
        "aria-label": placeholder,
        testId: "remix-overlay-describe-input",
        name: "remix-overlay-describe"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        type: "submit",
        appearance: "primary",
        isDisabled: !value?.trim(),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        label: formatMessage((0, $czfXc.default).describeSubmitLabel),
        testId: "remix-overlay-describe-submit"
    })))));
}
function $be6de585ac044839$export$ced6b2e82a17b9f6({ onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle }) {
    const isAnimatedArtworkEnabled = (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const [describeValue, setDescribeValue] = (0, $cozmU.useState)('');
    const [expandedOption, setExpandedOption] = (0, $cozmU.useState)(null);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const resolvedOptions = (0, $cozmU.useMemo)(()=>(0, $loej8.getRemixMenuOptions)({
            source: options === undefined ? {
                kind: 'preset',
                preset: 'selection'
            } : {
                kind: 'custom',
                choices: options
            },
            excludedRemixTypes: hiddenOptions ? [
                ...hiddenOptions
            ] : undefined
        }), [
        hiddenOptions,
        options
    ]);
    const handleDescribeSubmit = (0, $cozmU.useCallback)(()=>{
        onOptionSelect?.({
            type: 'custom',
            userPrompt: describeValue
        });
    }, [
        describeValue,
        onOptionSelect
    ]);
    const handleToggle = (0, $cozmU.useCallback)((type)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'remixOverlaySection',
            attributes: {
                sectionType: type
            }
        });
        setExpandedOption((prev)=>prev === type ? null : type);
    }, [
        sendAnalyticsEvent
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((type, subType)=>{
        const trimmedDescribe = describeValue?.trim();
        const userPrompt = trimmedDescribe || undefined;
        onOptionSelect?.({
            type: type,
            subType: subType,
            userPrompt: userPrompt
        });
    }, [
        onOptionSelect,
        describeValue
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)((type)=>{
        onOptionSelect?.({
            type: type
        });
    }, [
        onOptionSelect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixOverlayHeader, {
        subtitle: subtitle,
        isMinimized: expandedOption !== null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2WAcuGIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $be6de585ac044839$var$remixStyles.modalBodyPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "stretch",
        xcss: $be6de585ac044839$var$remixStyles.remixOptionsStack
    }, resolvedOptions.map((option)=>option.subTypes.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixAccordionOption, {
            key: option.type,
            option: option,
            isExpanded: expandedOption === option.type,
            isAnimatedArtworkEnabled: isAnimatedArtworkEnabled,
            onToggle: handleToggle,
            onSubTypeSelect: handleSubTypeSelect,
            onPickForMe: handlePickForMe,
            colorMode: colorMode
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixFlatOption, {
            key: option.type,
            option: option,
            onSelect: handlePickForMe
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixDescribeInput, {
        value: describeValue,
        onChange: setDescribeValue,
        onSubmit: handleDescribeSubmit,
        autoFocus: true
    }));
} /**
   * RemixOverlay — centered ADS Modal presentation
   */ 
function $be6de585ac044839$export$48a746fedb7ffb({ onClose: onClose, onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle }) {
    const setTabBoundaryRef = $be6de585ac044839$var$useTabBoundaryRef();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: 320,
        testId: "remix-overlay",
        shouldReturnFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: setTabBoundaryRef,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvDOLYo _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrunmFW"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), {
        hasInlinePadding: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixOpenMenuExperienceTracker, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$export$ced6b2e82a17b9f6, {
        onOptionSelect: onOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle
    })))));
} /**
   * Calls the Popup `update` function to reposition the popup whenever `repositionKey` changes.
   */ 
function $be6de585ac044839$var$PopupRepositionOnKeyChange({ repositionKey: repositionKey, update: update }) {
    const prevKey = (0, $cozmU.useRef)(repositionKey);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (prevKey.current !== repositionKey) {
            prevKey.current = repositionKey;
            update();
        }
    }, [
        repositionKey,
        update
    ]);
    return null;
} /**
   * RemixPopup — anchored ADS Popup presentation for contextual entry points (e.g. object-level sidebar).
   * No blanket, anchored to a trigger element.
   */ 
function $be6de585ac044839$export$a8b0b54f368ecbb0({ isOpen: isOpen, onClose: onClose, trigger: trigger, onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle, placement: placement = 'left-end', offset: offset = [
    8,
    16
], repositionKey: repositionKey, useCascadingMenu: useCascadingMenu = false, cascadingMenuHeader: cascadingMenuHeader, shouldCloseOnScroll: shouldCloseOnScroll = false, shouldPreserveEditorFocus: shouldPreserveEditorFocus = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [cascadeDirection, setCascadeDirection] = (0, $cozmU.useState)('right');
    const [hasMeasuredCascadeDirection, setHasMeasuredCascadeDirection] = (0, $cozmU.useState)(false);
    const [describeValue, setDescribeValue] = (0, $cozmU.useState)('');
    const effectivePlacement = useCascadingMenu && (placement === 'bottom-start' || placement === 'bottom-end') ? (0, $dcNzQ.getBottomPlacementForCascadeDirection)(cascadeDirection) : placement;
    const popupRepositionKey = useCascadingMenu ? `${repositionKey ?? ''}:${cascadeDirection}` : repositionKey;
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) {
            setCascadeDirection('right');
            setHasMeasuredCascadeDirection(false);
            setDescribeValue('');
        }
    }, [
        isOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen || !useCascadingMenu || !shouldCloseOnScroll) return;
        const handleScroll = (event)=>{
            const target = event.target;
            if (target instanceof Element && target.closest('[data-remix-cascading-popup]')) return;
            onClose();
        }; // Scroll does not bubble, so capture on window to observe page and nested scroll containers.
        return (0, $cbY7C.bind)(window, {
            type: 'scroll',
            listener: handleScroll,
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        onClose,
        shouldCloseOnScroll,
        useCascadingMenu
    ]);
    const updateCascadeDirectionFromTrigger = (0, $cozmU.useCallback)((triggerElement)=>{
        if (!useCascadingMenu || !triggerElement || !isOpen) return;
        const document = (0, $1hQ0e.getDocument)();
        const viewportWidth = window.innerWidth || document?.documentElement.clientWidth || 0;
        const nextDirection = (0, $dcNzQ.getCascadeDirectionForAnchor)(triggerElement.getBoundingClientRect(), viewportWidth);
        setCascadeDirection((currentDirection)=>currentDirection === nextDirection ? currentDirection : nextDirection);
        setHasMeasuredCascadeDirection(true);
    }, [
        isOpen,
        useCascadingMenu
    ]);
    const unbindPreserveFocusRef = (0, $cozmU.useRef)(null); // Callback ref so the listener re-attaches when the popup is closed and reopened.
    const setPreserveFocusRef = (0, $cozmU.useCallback)((element)=>{
        unbindPreserveFocusRef.current?.();
        unbindPreserveFocusRef.current = element && shouldPreserveEditorFocus ? $be6de585ac044839$var$bindPreserveFocusListener(element) : null;
    }, [
        shouldPreserveEditorFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        popupComponent: useCascadingMenu ? $be6de585ac044839$var$CascadingPopupContainer : undefined,
        onClose: onClose,
        placement: effectivePlacement,
        offset: offset,
        label: formatMessage((0, $czfXc.default).heading),
        role: "dialog",
        content: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixOpenMenuExperienceTracker, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$PopupRepositionOnKeyChange, {
                repositionKey: popupRepositionKey,
                update: update
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $be6de585ac044839$var$popupStyles.popupEnterAnimation
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                ref: setPreserveFocusRef,
                "data-editor-remix-inline-dropdown-preserve-focus": shouldPreserveEditorFocus || undefined,
                xcss: useCascadingMenu ? $be6de585ac044839$var$popupStyles.cascadingContentWrapper : $be6de585ac044839$var$popupStyles.contentWrapper,
                testId: "remix-popup"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: useCascadingMenu ? $be6de585ac044839$var$popupStyles.cascadingBody : $be6de585ac044839$var$popupStyles.body
            }, useCascadingMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcNzQ.RemixCascadingMenuContent), {
                onOptionSelect: onOptionSelect,
                options: options,
                hiddenOptions: hiddenOptions,
                flyoutDirection: cascadeDirection,
                showFlyout: hasMeasuredCascadeDirection,
                header: cascadingMenuHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    className: (0, $hekY6.default)([
                        "_1mT5xdRAKS _39xV02N91d"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                    xcss: $be6de585ac044839$var$popupStyles.cascadingHeader,
                    space: "space.050",
                    alignInline: "center",
                    testId: "remix-cascading-menu-header-content"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $be6de585ac044839$var$popupStyles.cascadingHeaderIcon,
                    "aria-hidden": "true"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($HvNsc))),
                    alt: "",
                    width: "100%"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                    size: "medium",
                    color: "color.text"
                }, formatMessage(cascadingMenuHeader.title)), cascadingMenuHeader.subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    color: "color.text"
                }, formatMessage(cascadingMenuHeader.subtitle)) : null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                    alignItems: "center",
                    justifyContent: "space-between",
                    testId: "remix-cascading-menu-header-content"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    weight: "semibold",
                    color: "color.text"
                }, formatMessage((0, $czfXc.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fkYYP.RemixLabsLozenge), null)),
                headerHasBottomPadding: Boolean(cascadingMenuHeader),
                headerCornerElement: cascadingMenuHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    "data-testid": "remix-cascading-labs-lozenge",
                    className: (0, $hekY6.default)([
                        "_1mT5xdWVPG _2IhTon8HPE _4ApkO28HPE _1pp6NdYbGa"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fkYYP.RemixLabsLozenge), null)) : undefined,
                footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixDescribeInput, {
                    value: describeValue,
                    isCompact: true,
                    onChange: setDescribeValue,
                    onSubmit: ()=>onOptionSelect?.({
                            type: 'custom',
                            userPrompt: describeValue
                        })
                })
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$export$ced6b2e82a17b9f6, {
                onOptionSelect: onOptionSelect,
                options: options,
                hiddenOptions: hiddenOptions,
                subtitle: subtitle
            }))))),
        trigger: (triggerProps)=>{
            if (!useCascadingMenu) return trigger(triggerProps);
            return trigger({
                ...triggerProps,
                ref: (triggerElement)=>{
                    $be6de585ac044839$var$setRef(triggerProps.ref, triggerElement);
                    updateCascadeDirectionFromTrigger(triggerElement);
                }
            });
        }
    });
}
module.exports["RemixOverlay"] = $be6de585ac044839$export$48a746fedb7ffb;
module.exports["RemixPopup"] = $be6de585ac044839$export$a8b0b54f368ecbb0;

});

parcelRegister("HvNsc", function(module, exports) {
module.exports = new URL("Remix-Illustration.7b8c03b3.svg", import.meta.url).toString();

});

parcelRegister("dcNzQ", function(module, exports) {
/* remix-cascading-menu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aDSIl = parcelRequire("aDSIl");


var $9d7Pd = parcelRequire("9d7Pd");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $1LRKz = parcelRequire("1LRKz");


var $czfXc = parcelRequire("czfXc");


var $9z4Bk = parcelRequire("9z4Bk");


var $loej8 = parcelRequire("loej8");

const $53abef11e3c2aac8$export$d7cf732af02b8895 = /*#__PURE__*/ (0, $cozmU.createContext)('down');
function $53abef11e3c2aac8$export$2ba0f43a8fa8308d(placement) {
    return placement?.startsWith('top') ? 'up' : 'down';
}
function $53abef11e3c2aac8$export$79e4d76f8b93a9a8(direction) {
    return direction === 'left' ? 'bottom-end' : 'bottom-start';
} // Width of a menu column (top-level categories and sub-type submenu).
const $53abef11e3c2aac8$var$CATEGORY_WIDTH = 280;
const $53abef11e3c2aac8$var$SUBTYPE_WIDTH = 160;
const $53abef11e3c2aac8$var$PREVIEW_WIDTH = 144;
const $53abef11e3c2aac8$var$PREVIEW_HEIGHT = 104;
const $53abef11e3c2aac8$var$CASCADE_COLUMN_GAP = 6;
const $53abef11e3c2aac8$var$CASCADE_VIEWPORT_MARGIN = 8;
const $53abef11e3c2aac8$var$CASCADE_FLYOUT_WIDTH = $53abef11e3c2aac8$var$SUBTYPE_WIDTH + $53abef11e3c2aac8$var$PREVIEW_WIDTH + $53abef11e3c2aac8$var$CASCADE_COLUMN_GAP * 2;
function $53abef11e3c2aac8$export$a1ba6991d30166a0(anchorRect, viewportWidth) {
    const fullCascadeWidth = $53abef11e3c2aac8$var$CATEGORY_WIDTH + $53abef11e3c2aac8$var$CASCADE_FLYOUT_WIDTH;
    const availableRightForFullCascade = viewportWidth - anchorRect.left - $53abef11e3c2aac8$var$CASCADE_VIEWPORT_MARGIN;
    const availableLeftForFlyout = anchorRect.left - $53abef11e3c2aac8$var$CASCADE_VIEWPORT_MARGIN;
    return availableRightForFullCascade < fullCascadeWidth && availableLeftForFlyout >= $53abef11e3c2aac8$var$CASCADE_FLYOUT_WIDTH ? 'left' : 'right';
}
const $53abef11e3c2aac8$var$subtleSlideIn = null;
const $53abef11e3c2aac8$var$menuStyles = {
    rootRightDown: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC",
    rootLeftDown: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5vf5Xk _0hPCNLchRC",
    rootRightUp: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLz9WS",
    rootLeftUp: "_2mHwu8gVvo _3iDTPbQ4SZ _0aFT5vf5Xk _0hPCNLz9WS",
    categoryColumn: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _1mT5xdRAKS _39xV02ehCh _3iDTPbQ4SZ _0aFT5vbt8w _0KLXruoI2d _2OUyjtGk8v",
    categoryHeader: "_46hvQm5zaO _0xmtko5zaO _0LQT5E5zaO _03SyCP5zaO",
    categoryHeaderNoBottomPadding: "_46hvQm5zaO _0xmtkoPgdg _0LQT5E5zaO _03SyCP5zaO",
    subTypeColumnPositioner: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _39xV02oaux",
    subTypeColumn: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _39xV02N91d _0KLXruoI2d _2OUyjtGk8v _1gBibyf9Pz _0nFVCG2HTN _43vdfTdisq _3Y6bKp38c8 _39Ohv4YbGa",
    previewColumnRight: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _39xV02Ka7A _0jFU0VbUtj _4xdlr0IZbP _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _46hvQm2ADO _0xmtko2ADO _0LQT5E2ADO _03SyCP2ADO _24h04i2Njc _0KLXruoI2d _2OUyjtGk8v _1kOSYtC67X _3Z9K0wb8VS _0qk6IKdisq _1SdfoHYbGa",
    previewColumnLeft: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _39xV02Ka7A _0jFU0VbUtj _4xdlr0IZbP _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _46hvQm2ADO _0xmtko2ADO _0LQT5E2ADO _03SyCP2ADO _24h04i2Njc _0KLXruoI2d _2OUyjtGk8v _1kOSYtC67X _3Z9K0wb8VS _0qk6IKdisq _1SdfoHYbGa",
    previewColumnImageEdgeToEdge: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _4c065UdnbC _2Y7lL4dnbC _39xV02Ka7A _0jFU0VbUtj _4xdlr0IZbP _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _0KLXruoI2d _2OUyjtGk8v _1kOSYtC67X _3Z9K0wb8VS _0qk6IKdisq _1SdfoHYbGa",
    previewImageEdgeToEdge: "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _00EA0eiObl",
    categoryTrailing: "_3iDTPbQ4SZ _0hPCNLDIqT",
    previewContent: "_39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa"
};
function $53abef11e3c2aac8$var$RemixSubTypeColumn({ subTypes: subTypes, categoryOffset: categoryOffset, pickForMeTestId: pickForMeTestId, onSubTypeSelect: onSubTypeSelect, onPickForMe: onPickForMe, onClearPreview: onClearPreview, onHoverSubType: onHoverSubType }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const verticalDirection = (0, $cozmU.useContext)($53abef11e3c2aac8$export$d7cf732af02b8895);
    const columnRef = (0, $cozmU.useRef)(null);
    const handleHoverSubType = (0, $cozmU.useCallback)((subTypeValue, rowElement)=>{
        const columnElement = columnRef.current;
        const rootElement = columnElement?.parentElement;
        if (!columnElement || !rootElement) {
            onHoverSubType(subTypeValue, {
                blockStart: 0,
                blockEnd: 0
            });
            return;
        }
        const rootRect = rootElement.getBoundingClientRect();
        const columnRect = columnElement.getBoundingClientRect();
        const rowRect = rowElement.getBoundingClientRect();
        const isFirstSubType = subTypes[0]?.value === subTypeValue;
        if (isFirstSubType) {
            // Reuse the subtype column's positioning source instead of measuring its translated top.
            // This prevents small rounding/timing differences between the first preview and the card.
            // Downward roots align from the top. Upward roots align from the bottom, so account for
            // the difference between the subtype and preview heights. Left/right does not affect it.
            onHoverSubType(subTypeValue, {
                blockStart: categoryOffset.blockStart,
                blockEnd: columnRect.height + categoryOffset.blockEnd - $53abef11e3c2aac8$var$PREVIEW_HEIGHT
            });
            return;
        } // Every non-first preview preserves the original exact row-centering calculation.
        const previewTop = rowRect.top + rowRect.height / 2 - $53abef11e3c2aac8$var$PREVIEW_HEIGHT / 2;
        onHoverSubType(subTypeValue, {
            blockStart: previewTop - rootRect.top,
            blockEnd: rootRect.bottom - previewTop - $53abef11e3c2aac8$var$PREVIEW_HEIGHT
        });
    }, [
        categoryOffset,
        onHoverSubType,
        subTypes
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: columnRef,
        xcss: $53abef11e3c2aac8$var$menuStyles.subTypeColumnPositioner,
        style: {
            transform: `translateY(${verticalDirection === 'up' ? -categoryOffset.blockEnd : categoryOffset.blockStart}px)`
        },
        testId: "remix-menu-submenu"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $53abef11e3c2aac8$var$menuStyles.subTypeColumn,
        testId: "remix-menu-submenu-surface"
    }, /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), null, /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), null, subTypes.map((subType)=>{
        const label = formatMessage(subType.labelMessage);
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: subType.value,
            testId: `remix-menu-subtype-row-${subType.value}`,
            onMouseEnter: (event)=>handleHoverSubType(subType.value, event.currentTarget),
            onFocus: (event)=>handleHoverSubType(subType.value, event.currentTarget)
        }, /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
            testId: subType.testId ?? `remix-menu-subtype-${subType.value}`,
            onClick: ()=>onSubTypeSelect(subType.value)
        }, label));
    })), /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        onMouseEnter: onClearPreview,
        onFocus: onClearPreview
    }, /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
        testId: pickForMeTestId,
        onClick: onPickForMe
    }, formatMessage((0, $czfXc.default).pickForMe)))))));
}
function $53abef11e3c2aac8$var$RemixPreviewColumn({ subType: subType, direction: direction, previewOffset: previewOffset, isAnimatedArtworkEnabled: isAnimatedArtworkEnabled }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const verticalDirection = (0, $cozmU.useContext)($53abef11e3c2aac8$export$d7cf732af02b8895);
    if (!subType) return null;
    const label = formatMessage(subType.labelMessage);
    const isImagePreview = subType.value === 'image';
    const IconComponent = isImagePreview ? null : (0, $9z4Bk.getSubTypeIconComponent)(subType.value, isAnimatedArtworkEnabled);
    const previewArtwork = isImagePreview ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "img",
        src: colorMode === 'dark' ? (0, $1LRKz.SUB_TYPE_ICON_URLS).image.dark : (0, $1LRKz.SUB_TYPE_ICON_URLS).image.light,
        alt: label,
        "aria-hidden": "true",
        xcss: $53abef11e3c2aac8$var$menuStyles.previewImageEdgeToEdge,
        testId: "remix-menu-preview"
    }) : IconComponent ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $53abef11e3c2aac8$var$menuStyles.previewContent,
        testId: "remix-menu-preview"
    }, /*#__PURE__*/ $cozmU.createElement(IconComponent, {
        alt: label
    })) : null;
    if (!previewArtwork) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: isImagePreview ? $53abef11e3c2aac8$var$menuStyles.previewColumnImageEdgeToEdge : direction === 'left' ? $53abef11e3c2aac8$var$menuStyles.previewColumnLeft : $53abef11e3c2aac8$var$menuStyles.previewColumnRight,
        style: {
            transform: `translateY(${verticalDirection === 'up' ? -previewOffset.blockEnd : previewOffset.blockStart}px)`
        },
        testId: "remix-menu-preview-column"
    }, previewArtwork);
}
function $53abef11e3c2aac8$var$RemixCategoryItem({ option: option, onActivate: onActivate, onFlatSelect: onFlatSelect }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const label = formatMessage(option.labelMessage);
    const optionIconAlt = formatMessage(option.iconAltMessage);
    const OptionIcon = option.icon;
    const hasSubTypes = option.subTypes.length > 0;
    if (!hasSubTypes) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: `remix-menu-category-row-${option.type}`,
        // `mouseenter`) whenever layout shifts under a stationary pointer. Focusing the
        // describe-prompt footer resizes the category column and repositions the popup, which
        // would otherwise "hover" whichever row slid under the cursor and open its flyout.
        // `mousemove` only fires for genuine pointer movement. `onActivate` is idempotent per
        // row, so the repeated calls while moving across a row collapse into one activation.
        onMouseMove: (event)=>onActivate(option, event.currentTarget),
        onFocus: (event)=>onActivate(option, event.currentTarget)
    }, /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
        iconBefore: /*#__PURE__*/ $cozmU.createElement(OptionIcon, {
            label: optionIconAlt,
            size: "small",
            color: "var(--ds-icon, #292A2E)"
        }),
        testId: option.testId,
        onClick: ()=>onFlatSelect(option.type)
    }, label));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: `remix-menu-category-row-${option.type}`,
        // when layout shifts under a stationary pointer.
        onMouseMove: (event)=>onActivate(option, event.currentTarget),
        onFocus: (event)=>onActivate(option, event.currentTarget)
    }, /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
        iconBefore: /*#__PURE__*/ $cozmU.createElement(OptionIcon, {
            label: optionIconAlt,
            size: "small",
            color: "var(--ds-icon, #292A2E)"
        }),
        iconAfter: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $53abef11e3c2aac8$var$menuStyles.categoryTrailing
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            color: "var(--ds-icon, #292A2E)",
            size: "small"
        })),
        testId: option.testId,
        onClick: (event)=>onActivate(option, event.currentTarget)
    }, label));
}
function $53abef11e3c2aac8$export$5d44e1d911d4366f({ onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, flyoutDirection: flyoutDirection = 'right', showFlyout: showFlyout = true, header: header, headerHasBottomPadding: headerHasBottomPadding = true, headerCornerElement: headerCornerElement, footer: footer }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const verticalDirection = (0, $cozmU.useContext)($53abef11e3c2aac8$export$d7cf732af02b8895);
    const isAnimatedArtworkEnabled = (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
    const categoryColumnRef = (0, $cozmU.useRef)(null);
    const resolvedOptions = (0, $cozmU.useMemo)(()=>(0, $loej8.getRemixMenuOptions)({
            source: options === undefined ? {
                kind: 'preset',
                preset: 'selection'
            } : {
                kind: 'custom',
                choices: options
            },
            excludedRemixTypes: hiddenOptions ? [
                ...hiddenOptions
            ] : undefined
        }), [
        hiddenOptions,
        options
    ]); // The category whose sub-types are currently shown in the second column. Only
    // categories that have sub-types open a flyout; the rest close it.
    const [activeType, setActiveType] = (0, $cozmU.useState)(null); // Measured from both edges of the active category row, positioning the subtype card.
    const [categoryOffset, setCategoryOffset] = (0, $cozmU.useState)({
        blockStart: 0,
        blockEnd: 0
    }); // The sub-type currently hovered/focused, driving the preview column.
    const [hoveredSubType, setHoveredSubType] = (0, $cozmU.useState)(null); // Measured from both root edges so the preview center follows the subtype row center,
    // including when edge-row previews extend beyond the subtype card.
    const [previewOffset, setPreviewOffset] = (0, $cozmU.useState)({
        blockStart: 0,
        blockEnd: 0
    });
    const activeOption = (0, $cozmU.useMemo)(()=>resolvedOptions.find((opt)=>opt.type === activeType && opt.subTypes.length > 0) ?? null, [
        resolvedOptions,
        activeType
    ]);
    const activeSubTypes = activeOption?.subTypes ?? [];
    const hoveredSubTypeDef = activeSubTypes.find((st)=>st.value === hoveredSubType) ?? null;
    const firstCategoryType = resolvedOptions[0]?.type; // The category row that most recently claimed the flyout. Kept in a ref rather than derived from
    // `activeType` because categories without sub-types also "claim" the flyout (by closing it), and
    // because it must stay stable across the repeated `mousemove` events fired while the pointer
    // travels across a single row.
    const activatedTypeRef = (0, $cozmU.useRef)(null); // Resets the sub-type preview. Deliberately bails out when there is nothing to clear, so it is
    // safe to call from the high-frequency `mousemove` path without forcing a re-render.
    const clearPreview = (0, $cozmU.useCallback)(()=>{
        setHoveredSubType(null);
        setPreviewOffset((current)=>current.blockStart === 0 && current.blockEnd === 0 ? current : {
                blockStart: 0,
                blockEnd: 0
            });
    }, []);
    const handleActivate = (0, $cozmU.useCallback)((option, rowElement)=>{
        if (activatedTypeRef.current === option.type) {
            // This row already owns the flyout — usually because the pointer is travelling back out
            // of the flyout across its own category row. The flyout and its offset are unchanged
            // (the row has not moved relative to the column), but any sub-type preview picked up on
            // the way out is now stale, so clear it exactly as a fresh activation would.
            clearPreview();
            return;
        }
        activatedTypeRef.current = option.type;
        if (option.subTypes.length > 0) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'opened',
            actionSubject: 'remixCascadingSubtypesMenu',
            attributes: {
                sectionType: option.type,
                remixType: option.type
            }
        });
        const categoryRect = categoryColumnRef.current?.getBoundingClientRect();
        const rowRect = rowElement.getBoundingClientRect();
        const isFirstCategory = option.type === firstCategoryType;
        setCategoryOffset(categoryRect ? {
            // ADS Section adds a 6px leading spacer before its first row. The first category's
            // flyout belongs at the category card edge, not below that internal content inset.
            blockStart: isFirstCategory ? 0 : Math.max(0, rowRect.top - categoryRect.top),
            blockEnd: Math.max(0, categoryRect.bottom - rowRect.bottom)
        } : {
            blockStart: 0,
            blockEnd: 0
        });
        setActiveType(option.subTypes.length > 0 ? option.type : null);
        clearPreview();
    }, [
        clearPreview,
        firstCategoryType,
        sendAnalyticsEvent
    ]);
    const handleHoverSubType = (0, $cozmU.useCallback)((subTypeValue, nextPreviewOffset)=>{
        setHoveredSubType(subTypeValue);
        setPreviewOffset(nextPreviewOffset);
    }, []); // Collapses the sub-type flyout and its preview back to the bare category column. Used when the
    // pointer or keyboard focus moves into the describe-prompt footer: the flyout belongs to a
    // category row, so leaving the category list for the free-text prompt must not leave a stale
    // submenu hanging beside the menu.
    const handleDismissFlyout = (0, $cozmU.useCallback)(()=>{
        if (activatedTypeRef.current === null) return;
        activatedTypeRef.current = null;
        setActiveType(null);
        clearPreview();
    }, [
        clearPreview
    ]);
    const handleFlatSelect = (0, $cozmU.useCallback)((type)=>{
        onOptionSelect?.({
            type: type
        });
    }, [
        onOptionSelect
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((subTypeValue)=>{
        if (!activeOption) return;
        const subTypeDef = activeOption.subTypes.find((st)=>st.value === subTypeValue);
        const remixType = (0, $iDrrr.fg)('cc-maui-phase-3') ? subTypeDef?.emitType ?? activeOption.type : activeOption.type;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'remixCascadingSubType',
            attributes: {
                sectionType: activeOption.type,
                remixType: remixType,
                remixSubtype: subTypeValue
            }
        });
        onOptionSelect?.({
            type: remixType,
            subType: subTypeValue
        });
    }, [
        activeOption,
        onOptionSelect,
        sendAnalyticsEvent
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)(()=>{
        if (!activeOption) return;
        const randomSubType = activeOption.subTypes[Math.floor(Math.random() * activeOption.subTypes.length)];
        if (!randomSubType) return;
        handleSubTypeSelect(randomSubType.value);
    }, [
        activeOption,
        handleSubTypeSelect
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: flyoutDirection === 'left' ? verticalDirection === 'up' ? $53abef11e3c2aac8$var$menuStyles.rootLeftUp : $53abef11e3c2aac8$var$menuStyles.rootLeftDown : verticalDirection === 'up' ? $53abef11e3c2aac8$var$menuStyles.rootRightUp : $53abef11e3c2aac8$var$menuStyles.rootRightDown,
        testId: "remix-menu"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: categoryColumnRef,
        xcss: $53abef11e3c2aac8$var$menuStyles.categoryColumn,
        testId: "remix-menu-categories"
    }, headerCornerElement, header ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: headerHasBottomPadding ? $53abef11e3c2aac8$var$menuStyles.categoryHeader : $53abef11e3c2aac8$var$menuStyles.categoryHeaderNoBottomPadding,
        testId: "remix-menu-header"
    }, header) : null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), null, /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), null, resolvedOptions.map((option)=>/*#__PURE__*/ $cozmU.createElement($53abef11e3c2aac8$var$RemixCategoryItem, {
            key: option.type,
            option: option,
            onActivate: handleActivate,
            onFlatSelect: handleFlatSelect
        }))))), footer ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box // `onFocus` maps to the bubbling `focusin`, so this also catches focus landing on the
    ), {
        // textarea or submit button nested inside the footer.
        onFocus: handleDismissFlyout,
        onMouseEnter: handleDismissFlyout,
        testId: "remix-menu-footer-region"
    }, footer) : null), showFlyout && activeOption ? /*#__PURE__*/ $cozmU.createElement($53abef11e3c2aac8$var$RemixSubTypeColumn, {
        key: activeType,
        subTypes: activeSubTypes,
        categoryOffset: categoryOffset,
        pickForMeTestId: `${activeOption.testId}-pick-for-me`,
        onSubTypeSelect: handleSubTypeSelect,
        onPickForMe: handlePickForMe,
        onClearPreview: clearPreview,
        onHoverSubType: handleHoverSubType
    }) : null, showFlyout && hoveredSubTypeDef ? /*#__PURE__*/ $cozmU.createElement($53abef11e3c2aac8$var$RemixPreviewColumn, {
        subType: hoveredSubTypeDef,
        direction: flyoutDirection,
        previewOffset: previewOffset,
        isAnimatedArtworkEnabled: isAnimatedArtworkEnabled
    }) : null);
}
module.exports["CascadeVerticalDirectionContext"] = $53abef11e3c2aac8$export$d7cf732af02b8895;
module.exports["getCascadeVerticalDirectionForPlacement"] = $53abef11e3c2aac8$export$2ba0f43a8fa8308d;
module.exports["getBottomPlacementForCascadeDirection"] = $53abef11e3c2aac8$export$79e4d76f8b93a9a8;
module.exports["getCascadeDirectionForAnchor"] = $53abef11e3c2aac8$export$a1ba6991d30166a0;
module.exports["RemixCascadingMenuContent"] = $53abef11e3c2aac8$export$5d44e1d911d4366f;

});

parcelRegister("lEf8v", function(module, exports) {
/**
 * React convenience for subscribing to remix commands for the lifetime of a
 * component. Ref-backed so the handler can close over fresh props/state without
 * re-subscribing each render (subscribe once, never stale).
 *
 * Typical use: a small component mounted near the remix surface that reacts to
 * commands — e.g. open chat on `RemixErrored`, toggle a plugin on
 * `RemixStarted`/`RemixGenerationEnded`/`RemixFlowEnded`.
 *
 * Additive; not wired into live flows.
 */ 
var $cozmU = parcelRequire("cozmU");


var $2sIE1 = parcelRequire("2sIE1");

const $e3010bf86102dcbc$export$b0620fc038952e0c = (handler)=>{
    const ref = (0, $cozmU.useRef)(handler);
    ref.current = handler;
    (0, $cozmU.useEffect)(()=>{
        // Stable proxy dispatching to the latest handler via the ref, so the
        // subscription is created once yet never goes stale.
        return (0, $2sIE1.registerRemixCommandHandler)((command)=>ref.current(command));
    }, []);
};
module.exports["useRemixCommands"] = $e3010bf86102dcbc$export$b0620fc038952e0c;

});

parcelRegister("6viot", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $5a36452a763e92e5$export$b673133280e4646e = ({ dynamicUiSource: dynamicUiSource, dynamicUiType: dynamicUiType, editorContext: editorContext, hasEditablePageContext: hasEditablePageContext, sourceContentId: sourceContentId })=>{
    const dynamicUiSourceToSend = dynamicUiSource ? {
        ...dynamicUiSource
    } : undefined;
    // Never forward a potentially stale ID supplied by the selected fragment.
    if (dynamicUiSourceToSend) delete dynamicUiSourceToSend.contentId;
    if (dynamicUiSourceToSend && dynamicUiType === 'custom' && dynamicUiSourceToSend.contentType === 'page' && sourceContentId && hasEditablePageContext && (0, $iDrrr.fg)('aifc_remix_custom_page_edit')) {
        dynamicUiSourceToSend.contentId = sourceContentId;
        return {
            dynamicUiSource: dynamicUiSourceToSend,
            editorContextFallback: editorContext,
            experienceParams: {
                experience: 'remix_custom_edit'
            }
        };
    }
    return {
        dynamicUiSource: dynamicUiSourceToSend,
        editorContextFallback: undefined,
        experienceParams: undefined
    };
};
module.exports["getCustomPageEditRequestParams"] = $5a36452a763e92e5$export$b673133280e4646e;

});

parcelRegister("3OD5k", function(module, exports) {
const $84c94bf7c9d9425b$export$5f321bb161ebfd54 = (contentType)=>contentType === 'blogpost' ? 'blogpost' : 'page';
module.exports["resolveRemixDynamicUiContentType"] = $84c94bf7c9d9425b$export$5f321bb161ebfd54;

});

parcelRegister("3rRes", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $4Aqqh = parcelRequire("4Aqqh");


var $1qYXT = parcelRequire("1qYXT");


var $6mKj3 = parcelRequire("6mKj3");

/**
 * Confluence product-side read of `REMIX_EXPANDS_EXPERIMENT`.
 *
 * Only invoked for expand node types (see `isRemixRestrictedNodeTypeWithExpands`), so filtering a
 * fragment without expands does not touch the experiment.
 */ const $b43257b5198523a8$var$areRemixExpandsEnabled = ()=>(0, $6mKj3.isExperimentEnabled)((0, $1qYXT.REMIX_EXPANDS_EXPERIMENT));
const $b43257b5198523a8$export$cee0b7c2921c06e1 = (nodes)=>{
    if (nodes === null) return null;
    const result = [];
    for (const node of nodes){
        const filtered = (0, $jTt8P.traverse)(node, {
            any: (adfNode)=>{
                if ((0, $1qYXT.isRemixRestrictedNodeTypeWithExpands)(adfNode.type, $b43257b5198523a8$var$areRemixExpandsEnabled)) return false;
            }
        });
        if (filtered !== false) result.push(filtered);
    }
    return result;
};
const $b43257b5198523a8$export$d6cdcf2c2885fa31 = (nodes)=>{
    if ((0, $6mKj3.isExperimentEnabled)('cc_maui_polish_changes_batch_6')) {
        if (nodes === null) return null;
        const sanitizedNodes = nodes.flatMap((node)=>{
            // The sanitizer can remove an invalid root node at runtime even though its legacy return
            // type only exposes JSONNode.
            const sanitizedNode = (0, $4Aqqh.sanitizeNode)(node, {
                keepNestedTables: true
            });
            return sanitizedNode === false ? [] : [
                sanitizedNode
            ];
        });
        return $b43257b5198523a8$export$cee0b7c2921c06e1(sanitizedNodes);
    }
    return $b43257b5198523a8$export$cee0b7c2921c06e1(nodes);
};
module.exports["filterRemixFragmentNodes"] = $b43257b5198523a8$export$cee0b7c2921c06e1;
module.exports["prepareRemixFragmentNodes"] = $b43257b5198523a8$export$d6cdcf2c2885fa31;

});

parcelRegister("caVF7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1118b6b7a2cd5d89$export$c8a930cce8a67fba = ({ onOpenPreview: onOpenPreview })=>{
    const [isComplete, setIsComplete] = (0, $cozmU.useState)(false);
    const signalActionReady = (0, $cozmU.useCallback)(()=>{
        // Defer opening the preview until the progress bar fills to 100%.
        setIsComplete(true);
    }, []);
    const resetCompletion = (0, $cozmU.useCallback)(()=>{
        setIsComplete(false);
    }, []);
    return (0, $cozmU.useMemo)(()=>({
            showProgressBar: true,
            isComplete: isComplete,
            onCompleteAnimationFinished: onOpenPreview,
            signalActionReady: signalActionReady,
            resetCompletion: resetCompletion
        }), [
        isComplete,
        onOpenPreview,
        signalActionReady,
        resetCompletion
    ]);
};
module.exports["useRemixThinkingBarProgress"] = $1118b6b7a2cd5d89$export$c8a930cce8a67fba;

});

parcelRegister("alDoy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $kDDrf = parcelRequire("kDDrf");


var $iBsvI = parcelRequire("iBsvI");

const $760703998eb424cc$export$6a00edcd422023c4 = 120000;
const $760703998eb424cc$export$fb8e95ec88bc76df = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const activeGenerationRef = (0, $cozmU.useRef)(undefined);
    const hasRecordedSuccessRef = (0, $cozmU.useRef)(false);
    const timeoutRef = (0, $cozmU.useRef)(undefined);
    const clearPotentialTimeout = (0, $cozmU.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
        }
    }, []);
    const createAttributes = (0, $cozmU.useCallback)((attributes)=>({
            ...attributes,
            featureArea: attributes.featureArea ?? (0, $iBsvI.getRemixFeatureArea)({
                remixType: attributes.remixType,
                existingFeatureArea: 'remix'
            }) ?? 'remix',
            remixCreateId: (0, $kDDrf.getActiveRemixCreateId)()
        }), []);
    const trackRemixSubmitted = (0, $cozmU.useCallback)((attributes)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'remixSubmit',
                source: attributes.remixSource ?? attributes.entryPoint,
                attributes: createAttributes(attributes)
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        createAttributes
    ]);
    const trackGenerationStarted = (0, $cozmU.useCallback)((attributes)=>{
        clearPotentialTimeout();
        const activeAttributes = createAttributes(attributes);
        activeGenerationRef.current = activeAttributes;
        hasRecordedSuccessRef.current = false;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'started',
                actionSubject: 'remixGeneration',
                source: attributes.remixSource ?? attributes.entryPoint,
                attributes: activeAttributes
            }
        }).fire();
        timeoutRef.current = setTimeout(()=>{
            const currentAttributes = activeGenerationRef.current;
            if (!currentAttributes) return;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'potentialTimeout',
                    actionSubject: 'remixGeneration',
                    source: currentAttributes.remixSource ?? currentAttributes.entryPoint,
                    attributes: currentAttributes
                }
            }).fire();
        }, $760703998eb424cc$export$6a00edcd422023c4);
    }, [
        clearPotentialTimeout,
        createAnalyticsEvent,
        createAttributes
    ]);
    const trackGenerationFinished = (0, $cozmU.useCallback)((action, attributes)=>{
        const activeAttributes = activeGenerationRef.current;
        if (!activeAttributes) return;
        if (action === 'succeeded' && hasRecordedSuccessRef.current) return;
        clearPotentialTimeout();
        const finalAttributes = {
            ...activeAttributes,
            ...attributes
        };
        if (action === 'failed') activeGenerationRef.current = undefined;
        else {
            hasRecordedSuccessRef.current = true;
            activeGenerationRef.current = undefined;
        }
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: action,
                actionSubject: 'remixGeneration',
                source: finalAttributes.remixSource ?? finalAttributes.entryPoint,
                attributes: finalAttributes
            }
        }).fire();
    }, [
        clearPotentialTimeout,
        createAnalyticsEvent
    ]);
    const trackGenerationStopped = (0, $cozmU.useCallback)((attributes)=>{
        const activeAttributes = activeGenerationRef.current;
        if (!activeAttributes) return;
        clearPotentialTimeout();
        activeGenerationRef.current = undefined;
        hasRecordedSuccessRef.current = false;
        const finalAttributes = {
            ...activeAttributes,
            ...attributes
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'stopped',
                actionSubject: 'remixGeneration',
                source: finalAttributes.remixSource ?? finalAttributes.entryPoint,
                attributes: finalAttributes
            }
        }).fire();
    }, [
        clearPotentialTimeout,
        createAnalyticsEvent
    ]);
    const trackGenerationFailed = (0, $cozmU.useCallback)((attributes)=>trackGenerationFinished('failed', attributes), [
        trackGenerationFinished
    ]);
    const trackGenerationSucceeded = (0, $cozmU.useCallback)((attributes)=>trackGenerationFinished('succeeded', attributes), [
        trackGenerationFinished
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            clearPotentialTimeout();
            activeGenerationRef.current = undefined;
            hasRecordedSuccessRef.current = false;
        }, [
        clearPotentialTimeout
    ]);
    return {
        trackGenerationFailed: trackGenerationFailed,
        trackGenerationStarted: trackGenerationStarted,
        trackGenerationStopped: trackGenerationStopped,
        trackGenerationSucceeded: trackGenerationSucceeded,
        trackRemixSubmitted: trackRemixSubmitted
    };
};
module.exports["useRemixGenerationAnalytics"] = $760703998eb424cc$export$fb8e95ec88bc76df;

});

parcelRegister("hxqA6", function(module, exports) {

var $2wo33 = parcelRequire("2wo33");


var $lfBMY = parcelRequire("lfBMY");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $kqIWy = parcelRequire("kqIWy");

const $37285b1cb0d2d316$var$NO_HIDDEN_OPTIONS = [];
const $37285b1cb0d2d316$var$ATTACHMENT_PERMISSION_HIDDEN_OPTIONS = [
    'infographic',
    'image'
];
const $37285b1cb0d2d316$var$DIAGRAM_HIDDEN_OPTION = [
    'diagram'
];
const $37285b1cb0d2d316$export$312403df3ff51f9f = ({ enabled: enabled = true } = {})=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: spaceDetail } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        includeSpaceTypeSettings: true,
        skip: !enabled
    });
    if (!enabled) return {
        didPrefetch: false,
        hiddenOptions: $37285b1cb0d2d316$var$NO_HIDDEN_OPTIONS
    };
    const isWhiteboardsEnabled = spaceDetail?.typeSettings?.enabledContentTypes?.isWhiteboardsEnabled ?? false;
    const enabledContentTypes = spaceDetail?.typeSettings?.enabledContentTypes;
    const hiddenOptions = [];
    // Only hide the diagram option when whiteboards are unavailable for the space.
    if (!isWhiteboardsEnabled) hiddenOptions.push('diagram');
    if (!enabledContentTypes?.isWhiteboardsEnabled) hiddenOptions.push('whiteboard');
    if (!enabledContentTypes?.isDatabasesEnabled) hiddenOptions.push('database');
    if (!enabledContentTypes?.isSlidesEnabled) hiddenOptions.push('slides');
    return {
        didPrefetch: true,
        hiddenOptions: hiddenOptions.length > 0 ? hiddenOptions : $37285b1cb0d2d316$var$NO_HIDDEN_OPTIONS
    };
};
const $37285b1cb0d2d316$export$ddcfdb99d720c6b3 = (options = {})=>$37285b1cb0d2d316$export$312403df3ff51f9f(options).hiddenOptions;
const $37285b1cb0d2d316$export$7a987497c37e0d9a = ({ enabled: enabled = true, contentId: contentIdOverride } = {})=>{
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = contentIdOverride ?? pageContentId;
    const isAttachmentPermissionsExperimentEnabled = enabled && (0, $6mKj3.expValEquals)('cc_maui_remix_attachment_permissions', 'isEnabled', true);
    const permissionContentId = isAttachmentPermissionsExperimentEnabled && contentId ? contentId : '';
    const canCreateAttachment = (0, $2wo33.useCanPerformContentOperation)({
        contentId: permissionContentId,
        operation: (0, $lfBMY.OperationTypes).CREATE,
        contentType: 'attachment'
    });
    const hiddenOptions = permissionContentId && canCreateAttachment !== true ? $37285b1cb0d2d316$var$ATTACHMENT_PERMISSION_HIDDEN_OPTIONS : $37285b1cb0d2d316$var$NO_HIDDEN_OPTIONS;
    // Fail closed while a real content permission is loading, but do not conflate missing page
    // context with a denial. Finalization still enforces permission server-side.
    return {
        didPrefetch: enabled && (!isAttachmentPermissionsExperimentEnabled || Boolean(permissionContentId)),
        hiddenOptions: hiddenOptions
    };
};
const $37285b1cb0d2d316$export$58fb19f16bd9996b = (options = {})=>$37285b1cb0d2d316$export$7a987497c37e0d9a(options).hiddenOptions;
const $37285b1cb0d2d316$export$3171169d240770c0 = ({ enabled: enabled = true, contentId: contentId } = {})=>{
    const attachmentOptions = $37285b1cb0d2d316$export$58fb19f16bd9996b({
        enabled: enabled,
        contentId: contentId
    });
    const isAttachmentPermissionsExperimentEnabled = enabled && // The attachment hook above records the exposure; this read keeps diagram behavior aligned.
    // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_maui_remix_attachment_permissions', 'isEnabled', true);
    const unavailableSpaceOptions = $37285b1cb0d2d316$export$ddcfdb99d720c6b3({
        enabled: isAttachmentPermissionsExperimentEnabled
    });
    const diagramOptions = unavailableSpaceOptions.includes('diagram') ? $37285b1cb0d2d316$var$DIAGRAM_HIDDEN_OPTION : [];
    return attachmentOptions.length > 0 || diagramOptions.length > 0 ? [
        ...attachmentOptions,
        ...diagramOptions
    ] : $37285b1cb0d2d316$var$NO_HIDDEN_OPTIONS;
};
const $37285b1cb0d2d316$export$aadb200d5bb732ca = ({ children: children, contentId: contentId, enabled: enabled })=>children($37285b1cb0d2d316$export$3171169d240770c0({
        contentId: contentId,
        enabled: enabled
    }));
module.exports["useSpaceRemixOptionsPrefetch"] = $37285b1cb0d2d316$export$312403df3ff51f9f;
module.exports["useShouldHideDiagramRemixOption"] = $37285b1cb0d2d316$export$ddcfdb99d720c6b3;
module.exports["useAttachmentRemixOptionsPrefetch"] = $37285b1cb0d2d316$export$7a987497c37e0d9a;
module.exports["useShouldHideAttachmentRemixOptions"] = $37285b1cb0d2d316$export$58fb19f16bd9996b;
module.exports["CommonRemixHiddenOptionsResolver"] = $37285b1cb0d2d316$export$aadb200d5bb732ca;

});

parcelRegister("7eOZ4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $iDrrr = parcelRequire("iDrrr");


var $dTEBe = parcelRequire("dTEBe");


var $hdBxM = parcelRequire("hdBxM");


var $kuGC4 = parcelRequire("kuGC4");


var $kNXXO = parcelRequire("kNXXO");

var $042Lk = parcelRequire("042Lk");


var $c5wKe = parcelRequire("c5wKe");


var $i7OAD = parcelRequire("i7OAD");


var $aYC8J = parcelRequire("aYC8J");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $gzMZq = parcelRequire("gzMZq");


var $hwgBi = parcelRequire("hwgBi");


var $8akfd = parcelRequire("8akfd");


var $lTU4O = parcelRequire("lTU4O");


var $6viot = parcelRequire("6viot");


var $loej8 = parcelRequire("loej8");


var $ew8wg = parcelRequire("ew8wg");


var $1AJi3 = parcelRequire("1AJi3");


var $6mKj3 = parcelRequire("6mKj3");


var $3jwuS = parcelRequire("3jwuS");


var $ep3mz = parcelRequire("ep3mz");


var $htsj6 = parcelRequire("htsj6");


var $ficwO = parcelRequire("ficwO");


var $jyA9t = parcelRequire("jyA9t");

const $1e31de274ed01603$var$isActionComplete = (chatMessages)=>{
    // Scan backwards to find ACTION_COMPLETE in the latest turn.
    // If we encounter a HUMAN message first, that marks a turn boundary —
    // any ACTION_COMPLETE before it belongs to a previous turn.
    let hasActionCompleteStep = false;
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') {
            hasActionCompleteStep = true;
            break;
        }
        if ((0, $igOtY.isStoreHuman)(message)) break;
    }
    const lastPlannedAIFCAction = (0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>(0, $i7OAD.isAIFCAction)(action) && action.status === 'planned');
    const hasCompletedAction = lastPlannedAIFCAction !== undefined;
    return hasActionCompleteStep || hasCompletedAction;
};
/**
 * True when the latest turn contains ACTION_PREPARE but no ACTION_COMPLETE.
 * This happens when AdfEditorMinion early-exits with "no operations returned
 * by LLM" — the stream completes but the action is never sealed.
 */ const $1e31de274ed01603$var$hasActionPrepareWithoutComplete = (chatMessages)=>{
    let hasActionPrepare = false;
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') return false;
        if (message.type === 'ACTION_PREPARE') hasActionPrepare = !!message.action && (0, $aYC8J.isRemixGeneratedFlow)(message.action);
        if ((0, $igOtY.isStoreHuman)(message)) break;
    }
    return hasActionPrepare;
};
function $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages) {
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_PREPARE') {
            if (!message.action) return false;
            if (!(0, $aYC8J.isRemixGeneratedFlow)(message.action)) return false;
            if ($1e31de274ed01603$var$isWhiteboardRemixActionKey(message.action.key) && !(0, $aYC8J.getDynamicUiSubtype)(message.action)) return false;
            return true;
        }
    }
    return false;
}
const $1e31de274ed01603$var$isWhiteboardRemixActionKey = (key)=>key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY);
/**
 * True when the latest matching assistant action is a whiteboard create/update
 * and checks if the action is in the ACTION_PART streaming status.
 * (`MessageAction.status === 'streaming'`).
 */ const $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming = (chatMessages)=>(0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>$1e31de274ed01603$var$isWhiteboardRemixActionKey(action.key) && action.status?.toLowerCase() === 'streaming') !== undefined;
const $1e31de274ed01603$export$cca9e2432f59b3f8 = ({ onActionReady: onActionReady, stagingAreaTargetMode: stagingAreaTargetMode = 'current-content', onPreviewOpened: onPreviewOpened, onSubmitted: onSubmitted, onPreviewDismissed: onPreviewDismissed, trackRemixConversationById: trackRemixConversationById = false } = {})=>{
    const { sendMessage: sendMessage, createConversationOptimistically: createConversationOptimistically, abortRequests: abortRequests, activeConversation: activeConversation, setSelectedConversation: setSelectedConversation } = (0, $c5wKe.useSmartCreationChatStoreApi)();
    const { setPrompt: setPrompt, setDynamicUiContext: setDynamicUiContext, setUserSelectedDynamicUiSubtype: setUserSelectedDynamicUiSubtype, setInteractionSource: setInteractionSource, setForceSkipAutoConversationSelection: setForceSkipAutoConversationSelection } = (0, $8akfd.useStagingAreaActions)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    const [editorContext] = (0, $gzMZq.useChatContextEditorContext)();
    const editorContextRef = (0, $cozmU.useRef)(editorContext);
    editorContextRef.current = editorContext;
    const hasEditablePageContext = editorContext !== undefined && editorContext.isViewMode !== true;
    const { openModal: openModal, closeModal: closeModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { openConversationAssistant: openConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { title: contentTitle } = (0, $ew8wg.usePageTitle)({
        contentId: contentId ?? ''
    });
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isDraftPage = contentStatus === 'draft';
    // Track the conversation ID created by this remix flow. Only when the
    // store's activeConversation matches this ID do we consider it "ours".
    // Stored as state so that setting it triggers a rerender, ensuring
    // derived values (activeRemixConversation, chatMessages, etc.) update
    // immediately rather than waiting for an external rerender.
    const [remixConversationId, setRemixConversationId] = (0, $cozmU.useState)(undefined);
    const outerCancellationIntentRef = (0, $cozmU.useRef)();
    const resetRemixConversationId = (0, $cozmU.useCallback)(()=>{
        outerCancellationIntentRef.current = undefined;
        setRemixConversationId(undefined);
    }, []);
    const remixConversation = (0, $kuGC4.useConversationById)({
        conversationId: remixConversationId ?? ''
    });
    const shouldTrackRemixConversationById = trackRemixConversationById && (0, $6mKj3.expVal)('cc_maui_polish_changes_batch_5', 'isEnabled', false);
    const activeRemixConversation = shouldTrackRemixConversationById ? remixConversation ?? null : activeConversation?.id && activeConversation.id === remixConversationId ? activeConversation : null;
    const remixConversationIdToRead = shouldTrackRemixConversationById ? remixConversationId : activeRemixConversation?.id;
    const [chatMessages] = (0, $iW40i.useChatMessages)({
        conversationId: remixConversationIdToRead ?? ''
    });
    const isRemixCancelled = shouldTrackRemixConversationById && remixConversation?.lastAgentMessageStatus === 'CANCELLED';
    // Extract the first StoreError from chatMessages so callers can surface
    // the specific Rovo error message as an experience attribute.
    const remixStoreError = chatMessages.find((message)=>(0, $igOtY.isStoreError)(message)) ?? null;
    // Detect whether Rovo encountered an error while processing a remix request.
    // This covers ACTION_ERROR at any stage — both before the ephemeral preview
    // opens (during awaitingResponse) and while it is loading (during typingResponse).
    // Uses the same isStoreError check as the smart-creation staging area.
    const isRemixError = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError || remixStoreError !== null;
    const [confirmedAskQuestion, setConfirmedAskQuestion] = (0, $cozmU.useState)();
    (0, $hdBxM.useSubscribe)({
        topic: 'ai-mate-chat-input-overlay'
    }, (payload)=>{
        if (payload.type !== 'task-ask-question-confirmed' || !(0, $iDrrr.fg)('platform_editor_ai_remix_disambiguation')) return;
        const { conversationId: confirmedConversationId, invocationId: invocationId } = payload.data;
        if (confirmedConversationId === remixConversationIdToRead) setConfirmedAskQuestion({
            conversationId: confirmedConversationId,
            invocationId: invocationId
        });
    });
    const hasAskQuestionAction = (0, $042Lk.lastAssistantHasAskQuestionAction)(chatMessages) && (0, $iDrrr.fg)('platform_editor_ai_remix_disambiguation');
    const askQuestionAction = hasAskQuestionAction ? (0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>action.key === 'ask_question') : undefined;
    const hasPendingAskQuestionAction = askQuestionAction !== undefined && askQuestionAction.status !== 'finished' && askQuestionAction.status !== 'cancelled' && askQuestionAction.status !== 'errored';
    const hasConfirmedCurrentQuestion = confirmedAskQuestion?.conversationId === remixConversationIdToRead && confirmedAskQuestion?.invocationId === askQuestionAction?.invocationId;
    const isWaitingForInput = hasPendingAskQuestionAction && !hasConfirmedCurrentQuestion;
    const hasOpenedRemixInputRequiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!isWaitingForInput) {
            hasOpenedRemixInputRequiredRef.current = false;
            return;
        }
        if ((0, $iDrrr.fg)('confluence_rovo_agent_session_nudges') || hasOpenedRemixInputRequiredRef.current) return;
        hasOpenedRemixInputRequiredRef.current = true;
        if (remixConversationIdToRead) (0, $dTEBe.updatePageRovoParams)({
            pathway: 'chat',
            conversationId: remixConversationIdToRead
        });
        openConversationAssistant('sidebar');
    }, [
        isWaitingForInput,
        openConversationAssistant,
        remixConversationIdToRead
    ]);
    const isRemixAborted = !isRemixError && !hasPendingAskQuestionAction && activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && !$1e31de274ed01603$var$isActionComplete(chatMessages) && !$1e31de274ed01603$var$hasActionPrepareWithoutComplete(chatMessages) && chatMessages.some((0, $igOtY.isStoreAssistant));
    // Track whether the onActionReady callback has already been fired for the
    // current conversation to avoid duplicate invocations.
    const actionReadyFired = (0, $cozmU.useRef)(false);
    // Reset the fired flag when the active remix conversation changes (new remix flow).
    const prevConversationId = (0, $cozmU.useRef)(activeRemixConversation?.id);
    (0, $cozmU.useEffect)(()=>{
        if (prevConversationId.current !== activeRemixConversation?.id) {
            actionReadyFired.current = false;
            prevConversationId.current = activeRemixConversation?.id;
        }
    }, [
        activeRemixConversation?.id
    ]);
    // Fire onActionReady when the appropriate message arrives:
    // - For whiteboard create/update: when the action is `streaming` (early trigger so
    //   the whiteboard preview can start rendering while data is still arriving).
    // - For all other actions: when FINAL_RESPONSE is received from the stream,
    //   indicated by the conversation status transitioning to `idle`.
    // - Fallback: when the stream completed (idle) with ACTION_PREPARE but no
    //   ACTION_COMPLETE (AdfEditorMinion early-exit).
    (0, $cozmU.useEffect)(()=>{
        if (actionReadyFired.current || !onActionReady || isRemixCancelled) return;
        const whiteboardStreamingDetected = $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming(chatMessages);
        const finalResponseReceived = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && $1e31de274ed01603$var$isActionComplete(chatMessages);
        const actionPreparedButNotCompleted = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && $1e31de274ed01603$var$hasActionPrepareWithoutComplete(chatMessages);
        if (whiteboardStreamingDetected || finalResponseReceived || actionPreparedButNotCompleted) {
            actionReadyFired.current = true;
            onActionReady();
        }
    }, [
        chatMessages,
        onActionReady,
        activeRemixConversation?.status,
        isRemixCancelled
    ]);
    const stopRemixing = (0, $cozmU.useCallback)((conversationId)=>{
        const remixCancellation = outerCancellationIntentRef.current;
        const shouldSettleCancellationIntent = conversationId === undefined || remixCancellation?.conversationId === conversationId;
        try {
            if (shouldSettleCancellationIntent && remixCancellation) (0, $hwgBi.recordRemixCancellation)(remixCancellation);
        } finally{
            if (shouldSettleCancellationIntent) outerCancellationIntentRef.current = undefined;
            // Without a conversation ID abortRequests aborts all conversations. Mismatch cleanup
            // passes this flow's retained conversation ID; no-argument callers keep the legacy scope.
            abortRequests?.({
                conversationId: conversationId ?? activeRemixConversation?.id
            });
        }
    }, [
        abortRequests,
        activeRemixConversation?.id
    ]);
    const openAIFCStagingModal = (0, $cozmU.useCallback)((options)=>{
        // Chart/visualization previews can become ready after Rovo has already
        // deactivated the conversation. Do not let a stale completion callback
        // open an empty modal after the user stopped that exact Remix.
        if (isRemixCancelled) return;
        setForceSkipAutoConversationSelection(true);
        // Open the Confluence Smart Creation Modal with stagingAreaActive=true
        // to skip the prompt screen and go straight to the staging area preview.
        //
        // Only keep the ephemeral preview for remix-generated preview content.
        // The shared helper currently treats dynamic UI, image-based remix flows,
        // and remix-generated whiteboards/diagrams as ephemeral-preview candidates.
        // All other ACTION_PREPARE results should open the full AIFC modal.
        //
        // Pass forceFullModal: true to bypass this check
        const shouldUseEphemeralPreview = options?.forceFullModal ? false : $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages);
        openModal({
            entryPoint: 'dynamicUi',
            spaceKey: spaceKey ?? undefined,
            parentContent: contentId && !isDraftPage ? {
                id: contentId,
                title: contentTitle ?? '',
                contentType: contentType ?? 'page'
            } : undefined,
            stagingAreaActive: true,
            isFloating: shouldUseEphemeralPreview,
            shouldShowBackButton: false,
            ...activeRemixConversation?.id && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) ? {
                remixConversationId: activeRemixConversation.id
            } : {},
            // `stagingAreaTargetMode` decides whether the current content is also
            // registered as staging-area content, or preserved only as parent/source
            // context for generated-content flows.
            ...stagingAreaTargetMode === 'current-content' && contentId ? {
                content: {
                    id: contentId,
                    type: contentType ?? 'page',
                    subType: isLivePage ? 'live' : null
                }
            } : {},
            // Pass a submitCallback only for ephemeral (floating) previews to
            // prevent navigating away from the current page. For the full modal flow
            // (e.g. "Add to Confluence"), omit the callback so the default
            // handleSubmitSmartCreate handler runs and redirects to the newly created content.
            ...shouldUseEphemeralPreview ? {
                submitCallback: async ()=>{
                    // Refresh the page tree for ephemeral previews only when the experiment is enabled.
                    if (!(0, $6mKj3.expVal)('cc-maui-refresh-page-tree-with-diagram', 'isEnabled', false)) return;
                    if (contentId) (0, $ficwO.publishMessage)((0, $ficwO.Message).PageTreeRefreshRequested, {
                        parentId: contentId
                    });
                }
            } : {},
            // Editor insertion acknowledgement is supplied only by machine-backed
            // Remix starts, which need the destination's durable-insertion result.
            ...options?.editorInsertionAcknowledgement ? {
                editorInsertionAcknowledgement: options.editorInsertionAcknowledgement
            } : {},
            onOpenCallback: options?.onPreviewOpened ?? onPreviewOpened,
            onSubmitCallback: options?.onSubmitted ?? onSubmitted,
            onCloseCallback: options?.onPreviewDismissed ?? onPreviewDismissed
        });
    }, [
        openModal,
        spaceKey,
        contentId,
        contentType,
        contentTitle,
        isLivePage,
        isDraftPage,
        activeRemixConversation?.id,
        isRemixCancelled,
        setForceSkipAutoConversationSelection,
        chatMessages,
        stagingAreaTargetMode,
        onPreviewOpened,
        onSubmitted,
        onPreviewDismissed
    ]);
    const sendAIFCPrompt = (0, $cozmU.useCallback)(async ({ userPrompt: userPrompt, promptText: promptTextOverride, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, dynamicUiSource: dynamicUiSource, interactionSource: interactionSource, forcedContentType: forcedContentType, additionalCreationContextParams: additionalCreationContextParams, conversationId: reuseConversationId, remixCancellationSessionId: remixCancellationSessionId })=>{
        const defaultPromptText = 'Remix the selected content';
        const selectedDisplayName = dynamicUiSubtype ? (0, $loej8.getSubTypeDisplayName)(dynamicUiSubtype) : (0, $loej8.getTypeDisplayName)(dynamicUiType);
        const autoText = `Remix the selected content as a ${selectedDisplayName}`;
        let promptText;
        if (promptTextOverride) promptText = promptTextOverride;
        else if (dynamicUiType === 'custom') promptText = userPrompt ?? defaultPromptText;
        else promptText = userPrompt ? `${autoText}. ${userPrompt}` : autoText;
        // Build the ADF DocNode prompt.
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: promptText
                        }
                    ]
                }
            ]
        };
        const newConversationId = reuseConversationId ?? (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        outerCancellationIntentRef.current = remixCancellationSessionId ? {
            sessionId: remixCancellationSessionId,
            conversationId: newConversationId,
            scope: 'outer-lifecycle'
        } : undefined;
        // Store the ID so we can identify this conversation as the active remix.
        setRemixConversationId(newConversationId);
        actionReadyFired.current = false;
        if (reuseConversationId && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2')) setSelectedConversation({
            conversationId: reuseConversationId
        });
        await createConversationOptimistically({
            id: newConversationId,
            ...shouldTrackRemixConversationById ? {
                isViewModeRemix: true
            } : {}
        });
        if (remixCancellationSessionId) // A reused Rovo conversation can still expose its previous generation's terminal
        // state. Activate only this admitted session after optimistic reset completes.
        (0, $hwgBi.activateRemixCancellationObservation)({
            conversationId: newConversationId,
            sessionId: remixCancellationSessionId
        });
        const { dynamicUiSource: dynamicUiSourceToSend, editorContextFallback: editorContextFallback, experienceParams: customPageEditExperienceParams } = (0, $6viot.getCustomPageEditRequestParams)({
            dynamicUiSource: dynamicUiSource,
            dynamicUiType: dynamicUiType,
            editorContext: editorContextRef.current,
            hasEditablePageContext: hasEditablePageContext,
            sourceContentId: contentId
        });
        let creationContextExperienceParams = {};
        if (!additionalCreationContextParams) {
            if (customPageEditExperienceParams) creationContextExperienceParams = customPageEditExperienceParams;
            else if (dynamicUiType === 'custom') creationContextExperienceParams = {
                experience: 'remix_custom'
            };
            else creationContextExperienceParams = {
                experience: 'remix',
                blocks: [
                    dynamicUiType
                ]
            };
        }
        // Send the message to Rovo
        sendMessage({
            prompt: prompt,
            storeUserMessages: preferences.storeUserMessages,
            conversationId: newConversationId,
            messageSources: {
                interactionSource: interactionSource,
                // Use the same source for follow-ups: Remix doesn't have a separate follow-up entry point, but the "viewed" AIMAU analytics event uses `followUpSource`.
                followUpSource: interactionSource
            },
            productKey: 'confluence',
            contentContext: 'staging-area',
            creationContextParams: {
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSourceToSend,
                source: 'remix',
                ...creationContextExperienceParams,
                ...forcedContentType ? {
                    forcedContentType: forcedContentType
                } : {},
                ...additionalCreationContextParams,
                ...dynamicUiType !== 'custom' && userPrompt ? {
                    hasUserInstruction: true
                } : {},
                // The object this Remix was initiated from, so the session can be anchored to it.
                // contentType is passed through as-is rather than defaulted to 'page': the backend
                // refuses an untyped id instead of minting an ARI for the wrong object type.
                ...(0, $iDrrr.fg)('confluence_remix_session_source_content') && contentId ? {
                    sourceContent: {
                        contentId: contentId,
                        contentType: contentType
                    }
                } : {}
            },
            editorContextFallback: editorContextFallback
        });
        // Store the prompt text for display in the staging area header.
        // Always show the brand keyword regardless of the user's custom prompt.
        setPrompt('Remix');
        // Persist the dynamic UI context so the update flow can use
        // the original type/source when sending remix adjustment messages
        setDynamicUiContext(dynamicUiType, dynamicUiSubtype, dynamicUiSourceToSend);
        // Keep the user's pick; setDynamicUiContext above gets overwritten with the
        // backend subtype on response, and EditWithRovoBar needs both to flag a mismatch.
        setUserSelectedDynamicUiSubtype(dynamicUiSubtype, newConversationId);
        setInteractionSource(interactionSource);
        return newConversationId;
    }, [
        createConversationOptimistically,
        sendMessage,
        setPrompt,
        setDynamicUiContext,
        setUserSelectedDynamicUiSubtype,
        setInteractionSource,
        setSelectedConversation,
        preferences.storeUserMessages,
        shouldTrackRemixConversationById,
        hasEditablePageContext,
        contentId,
        contentType
    ]);
    return {
        sendAIFCPrompt: sendAIFCPrompt,
        stopRemixing: stopRemixing,
        isRemixError: isRemixError,
        isRemixAborted: isRemixAborted,
        isWaitingForInput: isWaitingForInput,
        isRemixCancelled: isRemixCancelled,
        remixStoreError: remixStoreError,
        openAIFCStagingModal: openAIFCStagingModal,
        closeAIFCStagingModal: closeModal,
        remixConversationId: remixConversationId,
        resetRemixConversationId: resetRemixConversationId,
        setSelectedConversation: setSelectedConversation
    };
};
module.exports["useRemixToAIFC"] = $1e31de274ed01603$export$cca9e2432f59b3f8;

});

parcelRegister("HmpUb", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $5c4d53ab2c41ef66$export$18f828f11aef2dd3 = ()=>(0, $9wGTI.fg)('cc-maui-opted-out');
module.exports["isRemixOptedOut"] = $5c4d53ab2c41ef66$export$18f828f11aef2dd3;

});


//# sourceMappingURL=PageContentRendererFabric.3f216e69.js.map
